import {
  Box,
  Button,
  Grid,
  IconButton,
  List,
  ListItem,
  Checkbox as CHEckBox,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Colors } from "../../Constant/Color";
import CustomButton from "../../Components/Button";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import BasicSelect from "../../Components/Dropdown";
import { DataGrid } from "@mui/x-data-grid";
import Checkbox from "../../Components/checkbox";
import {
  CheckBox,
  ConnectingAirportsOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  UploadOutlined,
} from "@mui/icons-material";
import { Navigate, useNavigate } from "react-router-dom";
import { RingLoader } from "react-spinners";
import axios from "axios";
import { Base_Uri, Image_Uri } from "../../Constant/BaseUri";
import { useDispatch, useSelector } from "react-redux";
import { updateProducts } from "../../Redux/LoginReduces";
import RestockModal from "../../Components/restockmodal";
import AddProductModal from "../../Components/addProductModal";
import SaleHistoryModal from "../../Components/saleHistoryModal";
import SaleReturnHistoryModal from "../../Components/saleReturnHistoryModal";
import LedgerModal from "../../Components/ledgerModal";
import CustomModal from "../../Components/modal";
import BarcodePrintModal from "../../Components/printBarcodeModal";
import DescriptionModal from "../../Components/DescriptionModal";
import QRCode from "react-qr-code";
import * as XLSX from "xlsx";
import Modal from "@mui/material/Modal";
import { Popconfirm, Select, Checkbox as CheckBoxGroup, message, Modal as AntdModal, Progress, Button as AntdButton, Upload, Row, Col, Image } from "antd";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  PDFDownloadLink,
  StyleSheet,
} from "@react-pdf/renderer";
import { Fetch } from "socket.io-client";
import moment from "moment";

const styles = StyleSheet.create({
  page: { padding: 10, fontSize: 10 },
  header: {
    flexDirection: "row",
    borderBottom: "1px solid #000",
    marginBottom: 5,
  },
  headerText: { fontWeight: "bold", padding: 5 },
  row: {
    flexDirection: "row",
    borderBottom: "1px solid #ccc",
    marginBottom: 5,
  },
  cell: { height: 70, padding: 5 },
  highlightRow: {
    backgroundColor: "#FFCCCC", // Light red background for negative quantities
  },
});
const MyDocument = ({
  data,
  itemsPerPage = 10,
  selectedDepartment,
  AllPriceArrayToPrint = ["cost", "diamond", "platinum", "gold", "retail"],
}) => {
  let hfg =
    data?.reduce((total, item) => total + (Number(item?.qty) || 0), 0) || 0;
  // console.log(hfg, "d");
  const chunkedData = [];
  for (let i = 0; i < data.length; i += itemsPerPage) {
    chunkedData.push(data.slice(i, i + itemsPerPage));
  }
  return (
    <Document>
      {chunkedData.map((pageData, pageIndex) => (
        <Page style={styles.page}>
          {/* Header */}
          <View style={styles.header}>
            <Text style={[styles.headerText, { width: "40%" }]}>
              Product Name
            </Text>
            <Text style={[styles.headerText, { width: "10%" }]}>Quantity</Text>
            {AllPriceArrayToPrint.includes("cost") && (
              <Text style={[styles.headerText, { width: "10%" }]}>Cost</Text>
            )}
            {AllPriceArrayToPrint.includes("diamond") && (
              <Text style={[styles.headerText, { width: "10%" }]}>Diamond</Text>
            )}
            {AllPriceArrayToPrint.includes("platinum") && (
              <Text style={[styles.headerText, { width: "10%" }]}>
                Platinum
              </Text>
            )}
            {AllPriceArrayToPrint.includes("gold") && (
              <Text style={[styles.headerText, { width: "10%" }]}>Gold</Text>
            )}
            {AllPriceArrayToPrint.includes("retail") && (
              <Text style={[styles.headerText, { width: "10%" }]}>Retail</Text>
            )}
          </View>

          {/* Rows */}
          {pageData.map((item) => (
            <View
              style={[styles.row, item.qty < 0 && styles.highlightRow]}
              key={item.id}
            >
              <View style={[styles.cell, { width: "40%" }]}>
                <Text>{item.product_name}</Text>
                {selectedDepartment != "select" && (
                  <Text>IMEI: {item?.IMEI}</Text>
                )}
                {selectedDepartment != "select" && (
                  <Text>Color: {item?.product_color}</Text>
                )}
                  <Text>Barcode: {item?.barcode}</Text>
                  <Text>Sku: {item?.sku}</Text>
              </View>
              <Text style={[styles.cell, { width: "10%" }]}>{item.qty}</Text>
              {AllPriceArrayToPrint.includes("cost") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {item.cost_price.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("diamond") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {item.diamond.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("platinum") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {item.trade_price.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("gold") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {item.warehouse_price.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("retail") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {item.retail_price.toFixed(2)}
                </Text>
              )}
            </View>
          ))}
          {pageIndex === chunkedData.length - 1 && (
            <View style={styles.row} key={"total"}>
              <Text style={[styles.cell, { width: "40%" }]}>Total</Text>
              <Text style={[styles.cell, { width: "10%" }]}>
                {(
                  (data.length != 0 &&
                    data?.reduce(
                      (total, item) => total + (Number(item?.qty) || 0),
                      0
                    )) ||
                  0
                )?.toFixed(2)}
              </Text>
              {AllPriceArrayToPrint.includes("cost") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {(
                    (data.length != 0 &&
                      data?.reduce(
                        (total, item) =>
                          total +
                          (Number(item?.cost_price) * Number(item.qty) || 0),
                        0
                      )) ||
                    0
                  )?.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("diamond") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {(
                    (data.length != 0 &&
                      data?.reduce(
                        (total, item) =>
                          total +
                          (Number(item?.diamond) * Number(item.qty) || 0),
                        0
                      )) ||
                    0
                  )?.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("platinum") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {(
                    (data.length != 0 &&
                      data?.reduce(
                        (total, item) =>
                          total +
                          (Number(item?.trade_price) * Number(item.qty) || 0),
                        0
                      )) ||
                    0
                  )?.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("gold") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {(
                    (data.length != 0 &&
                      data?.reduce(
                        (total, item) =>
                          total +
                          (Number(item?.warehouse_price) * Number(item.qty) ||
                            0),
                        0
                      )) ||
                    0
                  )?.toFixed(2)}
                </Text>
              )}
              {AllPriceArrayToPrint.includes("retail") && (
                <Text style={[styles.cell, { width: "10%" }]}>
                  {(
                    (data.length != 0 &&
                      data?.reduce(
                        (total, item) =>
                          total +
                          (Number(item?.retail_price) * Number(item.qty) || 0),
                        0
                      )) ||
                    0
                  )?.toFixed(2)}
                </Text>
              )}
            </View>
          )}
        </Page>
      ))}
    </Document>
  );
};

const ExpandableRow = ({ row }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        aria-label="expand row"
        size="small"
        onClick={() => setOpen(!open)}
      >
        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      </IconButton>
      {open && (
        <Box sx={{ margin: 1 }}>
          <Typography variant="body2">{row.details}</Typography>
        </Box>
      )}
    </>
  );
};

function Products({ barcodeData, setBarcodeRead,HasProductAllLoad }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [calendarVisible, setCalendarVisible] = useState(false);
  const handleButtonClick = () => {
    setCalendarVisible(!calendarVisible); // Toggle calendar visibility
  };
const [selectedCollections, setSelectedCollections] = useState("");
  const [allCollections, setAllCollections] = useState([]);
// console.log(selectedCollections,"selectedCollections")
  // const filterProductsByDate = async(selectedDate) => {
  //   setSearchIsFilter(false);
  //   let filtered = products.filter((product) => {
  //     // Convert `created_at` from ISO string to date object for comparison
  //     const createdAtDate = new Date(product.created_at);
  //     // Compare the selected date with the created_at field
  //     return createdAtDate.toDateString() === selectedDate.toDateString();
  //   });
  //   filtered = await filtered?.map((e)=>({...e,id:e?._id}))
  //   // console.log(filtered,"filtered");
  //   // setSearchCategory(filtered.length != 0 ? filtered : []);
  //    setRows(filtered.length != 0 ? filtered : [])
  //   // setSearchIsFilter(filtered.length == 0);
  // };

  const filterProductsByDate = async(selectedDate) => {
    setSearchIsFilter(false);
    let filtered = products.filter((product) => {
      // Convert `created_at` from ISO string to date object for comparison
      const createdAtDate = new Date(product.created_at);
      // Compare the selected date with the created_at field
      return createdAtDate.toDateString() === selectedDate.toDateString();
    });
    filtered = await filtered?.map((e)=>({...e,id:e?._id}))
    // console.log(filtered,"filtered");
    // setSearchCategory(filtered.length != 0 ? filtered : []);
     setRows(filtered.length != 0 ? filtered : [])
    // setSearchIsFilter(filtered.length == 0);
  };
  
  const handleDateChange = (date) => {
    const onlyDate = date.toLocaleDateString("en-CA"); // YYYY-MM-DD format
  setSelectedDate(onlyDate);
    setCalendarVisible(false);
    // filterProductsByDate(date); // Optionally close the calendar after selecting a date
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const products = useSelector((state) => state?.loginReducer?.products);


  const userData = useSelector((state) => state.loginReducer.updatedState);

  const [category, setCategory] = useState([
    "mobile",
    "electronics",
    "clothes",
    "jewelery",
  ]);
  const [department, setDepartment] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridKey, setGridKey] = useState(0); // Add this state variable

  const [labelHeight, setLabelHeight] = useState(40);
  const [labelWidth, setLabelWidth] = useState(25);

  const [loader, setLoader] = useState({
    delete: false,
    active: false,
    inactive: false,
  });

  const [ledgerLoading, setLedgerLoading] = useState(false);

  const [filter, setFilter] = useState({
    active: false,
    inactive: false,
    restock: false,
    all: true,
  });

  const [openDescriptionModal, setOpenDescriptionModal] = useState(false);

  const [productClicked, setProductClicked] = useState("");
  const [product, setProducts] = useState([]);
  const [selectedItemsIds, setSelectedItemsIds] = useState(false);
  const [dataClicked, setDataClicked] = useState("");

  const [restockModal, setRestockModal] = useState(false);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [openSaleHistoryModal, setOpenSaleHistoryModal] = useState(false);
  const [openSaleReturnHistoryModal, setOpenSaleReturnHistoryModal] =
    useState(false);
  const [openLedgerModal, setOpenLedgerModal] = useState(false);
  const [openBarcodePrintModal, setOpenBarcodePrintModal] = useState(false);
  const [withPrice, setWithPrice] = useState(false);
  const [checked, setChecked] = React.useState([]);
  const [isWordpressUploadModal, setIsWordpressUploadModal] = useState(false);
  const [selectPriceStatus, setSelectPriceStatus] = useState("tp");
  const [inStockFilter, setInStockFilter] = useState(false);
  const [inMultipleSelectFilter, setInMultipleSelectFilter] = useState(false);
  const [isOpenModalPriceSelect, setIsOpenModalPriceSelect] = useState(false);
  const [AllPriceArrayToPrint, setAllPriceArrayToPrint] = useState([]);
  const handleToggle = (value) => () => {
    // console.log(value, "value");
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  
  useEffect(() => {
    if (products && products?.length > 0) {
      let allProducts = [...products];

      allProducts =
        allProducts &&
        allProducts.length > 0 &&
        allProducts?.map((e, i) => {
          if (Number(e?.qty) <= Number(e?.reminder_qty)) {
            return {
              ...e,
              status: "Restock",
            };
          } else {
            return e;
          }
        });

      setProducts(allProducts);
      dispatch(updateProducts(allProducts));
    }
  }, [products.length]);

  const [searchCategory, setSearchCategory] = useState([]);
  const [searchIsFilter, setSearchIsFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showcost, setShowCost] = useState(true);
 const [isModalOpen, setIsModalOpen] = useState(false);
 const [isModalOpen2, setIsModalOpen2] = useState(false);
 const [isModalBarcodeUpdate, setIsModalBarcodeUpdate] = useState(false);
 const [isModalSkuUpdate, setIsModalSkuUpdate] = useState(false);
 const [searchValueProduct,setSearchValueProduct] = useState("")
 const [searchValueProduct2,setSearchValueProduct2] = useState("")
  const [skuList, setSkuList] = useState([]);
  const [barcodeBulkList, setBarcodeBulkList] = useState([]);
    const [selectPriceStatusShopify, setSelectPriceStatusShopify] =
        useState("tp");
   const [jobId, setJobId] = useState(
    sessionStorage.getItem("syncJobId") || null
  );
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (jobId) {
      checkProgress(jobId);
    }
  }, [jobId]);

   const [addBarcode,setAddBarcode] = useState({})
  const [addSku,setAddSku] = useState({})

   const updateBarcode = ()=>{
      setLoading(true)
      if (!addBarcode?.value) {
        message.error("Add Barcode")
        setLoading(false)
        return
      }
  
      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
  
      if (token) {
        axios
          .put(`${Base_Uri}counter/barcode`,{id:addBarcode._id,item:Number(addBarcode?.value)}, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            let data = res.data;
            message.success("Barcode Updated")
            console.log(data,"data")
            setLoading(false)
          }).catch((err)=>{
            setLoading(false)
            console.log(err)
            message.error("Barcode not updated")
          })
        }
  
    }
    const updateSku = ()=>{
      setLoading(true)
      if (!addSku?.value) {
        message.error("Add Sku")
        setLoading(false)
        return
      }
  
      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
  
      if (token) {
        axios
          .put(`${Base_Uri}counter/sku`,{id:addSku._id,item:Number((addSku?.value))}, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            let data = res.data;
            message.success("SKU Updated")
            console.log(data,"data")
            setLoading(false)
          }).catch((err)=>{
            console.log(err)
            message.error("SKU not updated")
            setLoading(false)
          })
        }
  
    }

  
    useEffect(()=>{
  
      let data = sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
  
      if (token) {
        axios
          .get(`${Base_Uri}counter/get`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            let data = res.data;
            setAddBarcode(data?.filter((e)=>e.name=="barcodeCounter")?.[0])
            setAddSku(data?.filter((e)=>e.name=="skuCounter")?.[0])
          })
        }
    },[])

  const handleOpenDescriptionModal = (product) => {
    setDataClicked(product);
    setOpenDescriptionModal(true);
  };
  const SyncProduct = () => {
    setLoading(true);
    axios
      .post(`${Base_Uri}syncquantities`)
      .then((data) => {
        message.info("Product sync successful");
        setLoading(false);
      })
      .catch((error) => {
        // console.log(error, "error");
        message.info("Product sync not successful");
        setLoading(false);
      });
  };
 const checkProgress = (id) => {
    const interval = setInterval(async () => {
      const res = await axios.get(`${Base_Uri}syncStatus/${id}`);
      const data = await res.data;

      setProgress(data.progress);
      setStatus(data.status);

      if (data.status === "done") {
        clearInterval(interval);
        sessionStorage.removeItem("syncJobId");
      }

      if (data.status === "failed") {
        clearInterval(interval);
        sessionStorage.removeItem("syncJobId");
      }
    }, 1500);
  };

   const startSync = async () => {
    const res = await axios.post(`${Base_Uri}startSync`,{excelDataArray:skuList.join(","),pr:selectPriceStatusShopify});
    const data = await res.data;

    sessionStorage.setItem("syncJobId", data.jobId);
    setJobId(data.jobId);
    setStatus("running");

    checkProgress(data.jobId);
  };
  const handleExcelUpload = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet);

      if (!rows.length) {
        message.error("Excel file is empty!");
        return false;
      }

      // AUTO-DETECT SKU COLUMN
      let firstRowKeys = Object.keys(rows[0]);
      let skuColumn = firstRowKeys.find((key) =>
        key.toLowerCase().includes("sku")
      );

      if (!skuColumn) {
        message.error("No SKU column found!");
        return false;
      }

      const extractedSkus = rows
        .map((row) => row[skuColumn])
        .filter((v) => v && v.toString().trim() !== "");

      setSkuList(extractedSkus);
      setIsModalOpen(true);

      message.success(`Found ${extractedSkus.length} SKUs`);
    } catch (err) {
      message.error("Invalid file");
    }

    return false; // prevent auto-upload
  };
  const handleExcelUpload2 = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet);

      if (!rows.length) {
        message.error("Excel file is empty!");
        return false;
      }

      // AUTO-DETECT SKU COLUMN
      let firstRowKeys = Object.keys(rows[0]);
      let skuColumn = firstRowKeys.find((key) =>
        key.toLowerCase().includes("barcode")
      );

      if (!skuColumn) {
        message.error("No SKU column found!");
        return false;
      }

      const extractedSkus = rows
        .map((row) => row[skuColumn])
        .filter((v) => v && v.toString().trim() !== "").map((e)=>e.toString());

      setBarcodeBulkList(extractedSkus);
      setIsModalOpen2(true);

      message.success(`Found ${extractedSkus.length} barcodes`);
    } catch (err) {
      message.error("Invalid file");
    }

    return false; // prevent auto-upload
  };
  const reloadPage = () => {
    window.location.reload();
  };


  
  const uploadProductOnWordpress = (productIDs) => {
    // console.log("hello", productIDs);
    setLoading(true);
    let productID = [productIDs].join(","); // retail_price = rp, trade_price = tp, warehouse_price = wp, cost_price = cp
    axios
      .post(
        `${Base_Uri}addProductOnWordpress?id=${productID}&pr=${selectPriceStatus}`
      )
      .then((data) => {
        if (data.data.status == 1) {
          setLoading(false);
          message.info("Prdouct Upload Successfully");
        } else if (data.data.status == 2) {
          setLoading(false);
          message.info("Product is already exist:");
        } else {
          setLoading(false);
          message.info(data.data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        message.info("Error adding product:1");
      });
  };
   const uploadProductOnShopify = (productIDs) => {
    // console.log("hello", productIDs);
    // console.log(Image_Uri,"l")
    // console.log(selectedCollections,"lc")
    setLoading(true);
    let productID = [productIDs].join(","); // retail_price = rp, trade_price = tp, warehouse_price = wp, cost_price = cp
    axios
      .post(
        `${Base_Uri}addProductOnShopify?id=${productID}&pr=${selectPriceStatus}&imuri=${Image_Uri}&collection=${selectedCollections}`
      )
      .then((data) => {
        if (data.data.status == 1) {
          setLoading(false);
          message.info("Prdouct Upload Successfully");
          // console.log(data.data,"k")
        } else if (data.data.status == 2) {
          setLoading(false);
          message.info("Product is already exist:");
        } else {
          setLoading(false);
          message.info(data.data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        message.info("Error adding product:1");
      });
  };
  const updateProductOnWordpress = (productID) => {
    // // console.log("hello",productIDs)
    setLoading(true);
    axios
      .post(
        `${Base_Uri}updateProductOnWordpress?id=${productID}&pr=${selectPriceStatus}`
      )
      .then((data) => {
        if (data.data.status == 1) {
          setLoading(false);
          message.info("Prdouct Update Successfully");
        } else if (data.data.status == 2) {
          setLoading(false);
          message.info("Product is already exist:");
        } else {
          setLoading(false);
          message.info(data.data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        message.info("Error adding product:1");
      });
  };
  const fileInputRef = useRef();
  const fileInputRef2 = useRef();
  const handleExcelFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      readExcel(file);
    }
  };
  const convertArrayToObject = (dataArray) => {

    // console.log(dataArray,"dataArray")
    if (Array.isArray(dataArray)) {
      const headers = dataArray[0];
      const dataObjects = [];

      for (let i = 1; i < dataArray.length; i++) {
        const currentRow = dataArray[i];
        const rowDataObject = {};

        if (currentRow.length > 0) {
          for (let j = 0; j < headers.length; j++) {
            rowDataObject[headers[j]] = currentRow[j];
          }
          dataObjects.push(rowDataObject);
        }
      }
      setLoading(false);
      return dataObjects;
    }
  };

  const readExcel = async (file) => {
    setLoading(true);

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = e.target.result;

      if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
        message.info("Invalid file. Please upload a valid Excel file.");
        setLoading(false);
        return;
      }

      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      let arrayOfObjects = convertArrayToObject(jsonData);
      console.log(arrayOfObjects,"arrayOfObjects")
      let duplicateArrayOfObject = [...arrayOfObjects]
      for (let i = 0; i < duplicateArrayOfObject.length; i++) {
        const element = duplicateArrayOfObject[i];
          if (element?.sku) {
            continue
          }
           if (arrayOfObjects?.[i-1]?.image2_url&&!arrayOfObjects?.[i-1]?.image3_url ) {
           arrayOfObjects[i-1].image3_url = element?.image1_url||""
         }
         if (!arrayOfObjects[i-1].image2_url ) {
           arrayOfObjects[i-1].image2_url = element?.image1_url||""
         }
      }
      arrayOfObjects = arrayOfObjects.filter((e)=>e.sku)
      console.log(arrayOfObjects,"arrayOfObjects2")
      let furnisedProduct = [];
      for (var i = 0; i < arrayOfObjects?.length; i++) {
        let data = arrayOfObjects[i];
        // console.log(data);
        let {
          ProductName,
          productDescription,
          colors,
          image1,
          image2,
          image3,
          department,
          category,
          Sub_Category,
          make,
          model,
          qty,
          remind,
          supplier_name,
          supplier_address,
          supplier_mobile_number,
          cost_price,
          gold,
          platinum,
          diamond,
          retail_price,
          barCode,
          sku,
          IMEI,
          compatibility,
          in_shopify,new_ledger,image1_url,
        image2_url,
        image3_url,
        price_selected
        } = data;

        if (
          !barCode&&!sku
          // !cost_price ||
          // !trade_price ||
          // !retail_price ||
          // !warehouse_price
        ) {
          message.info(
            `Required fields are missing check your file and make nacessary changes ${i}`
          );
          return;
        }
        if (productDescription) {
          productDescription = productDescription.replace(/<\/?[^>]+(>|$)/g, '')
        }
        furnisedProduct.push({
          product_name: ProductName,
          product_description: productDescription,
          product_color: colors,
          supplier_name: supplier_name,
          supplier_address: supplier_address,
          supplier_mobile_number: supplier_mobile_number,
          department: department,
          category: category,
          sub_category: Sub_Category,
          make: make,
          model: model,
          qty: qty,
          reminder_qty: remind,
          cost_price: cost_price,
          diamond: diamond,
          warehouse_price: gold,
          trade_price: platinum,
          retail_price: retail_price,
          barcode: barCode,
          sku: sku,
          IMEI,
          compatibility,
          in_shopify,
          new_ledger,image1_url,
        image2_url,
        image3_url,
        price_selected
        });
      }
      let arrayOfObjectss = furnisedProduct.map((obj) => {
        return Object.fromEntries(
          Object.entries(obj).filter(
            ([_, value]) =>
              value !== null &&
              value !== undefined &&
              value !== "" &&
              !(typeof value === "string" && value.trim() === "")
          )
        );
      });
      // console.log(arrayOfObjectss, "l");
      setLoading(true);
      let myData = await sessionStorage.getItem("userData");
      myData = JSON.parse(myData);
      let token = myData;
      await axios
        .put(`${Base_Uri}editmultipleproducts`, arrayOfObjectss, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((data) => {
          // console.log(data.data);
          setLoading(false);
          message.info("Succesfully Uploaded");
        })
        .catch((err) => {
          setLoading(false);
          // console.log(err);
          message.info("Not Succesfully Uploaded");
        });
      // setExcelData(arrayOfObjects);
      // setProductAddModalVisible(true);
    };

    reader.readAsBinaryString(file);
  };

  const handleButtonClickFile = () => {
    // Trigger the file input click event
    fileInputRef.current.click();
  };
  const deleteProductOnWordpress = (productID) => {
    setLoading(true);
    // let productID = [productIDs].join(",")
    axios
      .post(`${Base_Uri}deleteProductOnWordpress?id=${productID}`)
      .then((data) => {
        if (data.data.status == 1) {
          setLoading(false);
          message.info("Prdouct Delete Successfully");
        } else if (data.data.status == 2) {
          setLoading(false);
          message.info("Product is not exist:");
        } else {
          setLoading(false);
          message.info(data.data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        message.info("Error adding product:1");
      });
  };
  const deleteProductOnShopify = (productID) => {
    setLoading(true);
    // let productID = [productIDs].join(",")
    axios
      .post(`${Base_Uri}deleteProductOnShopify?id=${productID}`)
      .then((data) => {
        if (data.data.status == 1) {
          setLoading(false);
          message.info("Prdouct Delete Successfully");
        } else if (data.data.status == 2) {
          setLoading(false);
          message.info("Product is not exist:");
        } else {
          setLoading(false);
          message.info(data.data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        message.info("Error adding product:1");
      });
  };
  const uploadBulkProductOnWordpress = () => {
    setLoading(true);
    let productID = checked.join(",");
    axios
      .post(`${Base_Uri}addProductOnWordpress?id=${productID}`)
      .then((data) => {
        if (data.data.status == 1) {
          setLoading(false);
          message.info("Prdouct Upload Successfully");
        } else if (data.data.status == 2) {
          setLoading(false);
          message.info("Product is already exist:");
        } else {
          setLoading(false);
          message.info(data.data.msg);
        }
      })
      .catch(() => {
        setLoading(false);
        message.info("Error adding product:1");
      });
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { lg: "35%", md: "40%", sm: "55%", xs: "100%" },
    borderRadius: "10px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };
  const getImageUrl = (img) => {
  if (!img) return null;
  return img.startsWith("http")
    ? img
    : `${Image_Uri}products/${img}`;
};

  const [column, setColumn] = useState([
   

    {
      field: "barcode",
      headerName: "Barcode",
      width: "130",
      headerClassName: "super-app-theme--header",
    },
    {
      field: "sku",
      headerName: "SKU",
      width: "130",
      headerClassName: "super-app-theme--header",
    },
    {
      field: "images",
      headerName: "Image",
      width: "80",
      headerClassName: "super-app-theme--header",
      renderCell: (cellValues) => {
  const { image1_url, image2_url, image3_url } = cellValues?.row || {};

  const images = [image1_url, image2_url, image3_url]
    .map(getImageUrl)
    .filter(Boolean); // remove null/undefined

  if (!images.length) {
    return (
      <img
        src="https://demofree.sirv.com/nope-not-here.jpg"
        style={{ height: 60, width: 80 }}
      />
    );
  }

  return (
    <Image.PreviewGroup>
      {/* show only first image */}
      <Image
        src={images[0]}
        style={{ height: 60, width: 80, objectFit: "cover" }}
        preview={{ visible: false }}
      />

      {/* hidden images but included in preview */}
      {images.slice(1).map((img, i) => (
        <Image key={i} src={img} style={{ display: "none" }} />
      ))}
    </Image.PreviewGroup>
  )
}
    },
    {
      field: "product_name",
      headerName: "Product Name",
      headerClassName: "super-app-theme--header",
      minWidth: "600",
      // renderCell: (params) => <ExpandableRow row={params.row} />
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top">
          <Typography noWrap style={{ maxWidth: "100%" }}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },

    {
      field: "qty",
      headerClassName: "super-app-theme--header",
      headerName: "Quantity",
      width: "120",
    },
    {
      field: "frozen_qty",
      headerClassName: "super-app-theme--header",
      headerName: "Hold Qty",
      width: "120",
    },
    {
      field: "cost_price",
      headerClassName: "super-app-theme--header",
      headerName: "Cost",
      width: "120",
      renderCell: (cellValues) => {
        return <p>{Number(cellValues?.row?.cost_price).toFixed(2)}</p>;
      },
    },
    {
      field: "diamond",
      headerClassName: "super-app-theme--header",
      headerName: "Diamond",
      width: "120",
      renderCell: (cellValues) => {
        return <p>{Number(cellValues?.row?.diamond).toFixed(2)}</p>;
      },
    },
    {
      field: "trade_price",
      headerName: "Platinum",
      headerClassName: "super-app-theme--header",
      width: "120",
      renderCell: (cellValues) => {
        return <p>{Number(cellValues?.row?.trade_price).toFixed(2)}</p>;
      },
    },
    {
      field: "warehouse_price",
      headerName: "Gold",
      headerClassName: "super-app-theme--header",
      width: "120",
      renderCell: (cellValues) => {
        return <p>{Number(cellValues?.row?.warehouse_price).toFixed(2)}</p>;
      },
    },

    {
      field: "retail_price",
      headerName: "Retail",
      headerClassName: "super-app-theme--header",
      width: "120",
      renderCell: (cellValues) => {
        return <p>{Number(cellValues?.row?.retail_price).toFixed(2)}</p>;
      },
    },

    {
      field: "compatibility",
      headerName: "Compatibility",
      headerClassName: "super-app-theme--header",
      width: 300,
      renderCell: (cellValues) => {
        return (
          <p>
            {cellValues?.row?.compatibility
              ? cellValues?.row?.compatibility
              : "-"}
          </p>
        );
      },
    },
    {
      field: "in_wordpress",
      headerName: "In Wordpress",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div>
            <Popconfirm
              title={
                cellValues?.row?.in_wordpress &&
                cellValues?.row?.update_product_wordpress
                  ? "Update"
                  : "Upload"
              }
              description={
                <div>
                  <div>
                    Are you sure to{" "}
                    {cellValues?.row?.in_wordpress &&
                    cellValues?.row?.update_product_wordpress
                      ? "Update"
                      : "Upload"}{" "}
                    on wordpress?
                  </div>
                  <Select
                    defaultValue="tp"
                    onChange={(e) => setSelectPriceStatus(e)}
                    options={[
                      { value: "cp", label: "Cost" },
                      { value: "di", label: "Diamond" },
                      { value: "tp", label: "Platinum" },
                      { value: "wp", label: "Gold" },
                      { value: "rp", label: "Retail" },
                    ]}
                  />
                </div>
              }
              a
              onConfirm={() =>
                cellValues?.row?.in_wordpress &&
                cellValues?.row?.update_product_wordpress
                  ? updateProductOnWordpress(cellValues?.row?._id)
                  : uploadProductOnWordpress(cellValues?.row?._id)
              }
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  color:
                    cellValues?.row?.in_wordpress &&
                    cellValues?.row?.update_product_wordpress &&
                    "green",
                }}
                //  onClick={() => uploadProductOnWordpress(cellValues?.row?._id)}
                disabled={
                  cellValues?.row?.in_wordpress &&
                  !cellValues?.row?.update_product_wordpress
                }
              >
                {cellValues?.row.in_wordpress &&
                cellValues?.row?.update_product_wordpress
                  ? "Update on wordpress"
                  : "Upload on Wordpress"}
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
    },
    {
      field: "in_shopify",
      headerName: "In Shopify",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div >
            <Popconfirm
              title={
                cellValues?.row?.in_shopify &&
                cellValues?.row?.update_product_shopify
                  ? "Update"
                  : "Upload"
              }
              description={
                <div onClick={(e) => e.stopPropagation()}>
                  <div>
                    Are you sure to{" "}
                    {cellValues?.row?.in_shopify &&
                    cellValues?.row?.update_product_shopify
                      ? "Update"
                      : "Upload"}{" "}
                    on shopify?
                  </div>
                  <Select
                    defaultValue="tp"
                    onChange={(e) => setSelectPriceStatus(e)}
                    options={[
                      { value: "cp", label: "Cost" },
                      { value: "di", label: "Diamond" },
                      { value: "tp", label: "Platinum" },
                      { value: "wp", label: "Gold" },
                      { value: "rp", label: "Retail" },
                    ]}
                  />
                  <Select
                placeholder={"Select Collections"}
                style={{width:200}}
                // value={selectedCollections}
                // onClick={(e)=>e.stopPropagation()}
                  onChange={(e) => {
                    setSelectedCollections(e)
                    
                    // console.log(e,"lk")
                  }}
                  options={[
  { label: "Apple", value:"653084557639" },
  { label: "Batteries", value:"651312529735" },
  { label: "Batteries, Samsung Parts", value:"653060145479" },
  { label: "Camera Lens & Sensors", value:"651315249479" },
  { label: "Charging Board", value:"651942396231" },
  { label: "Charging Ports / Flex Cables", value:"651315151175" },
  { label: "Console Parts", value:"651455529287" },
  { label: "Featured", value:"651462738247" },
  { label: "Google", value:"651888656711" },
  { label: "Home page", value:"648078819655" },
  { label: "iphone 17 pro max", value:"652896928071" },
  { label: "LCD Screens", value:"653060211015" },
  { label: "LCD Screens, Samsung Parts", value:"653060047175" },
  { label: "Phone Accessories & Repair Parts", value:"651315446087" },
  { label: "Phone Screens & LCDs", value:"651314954567" },
  { label: "Sim Tray", value:"652461474119" }
]}
                />
               
                </div>
              }
              
              onConfirm={() =>
                cellValues?.row?.in_shopify &&
                cellValues?.row?.update_product_shopify
                  ? updateProductOnWordpress(cellValues?.row?._id)
                  : uploadProductOnShopify(cellValues?.row?._id)
              }
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  color:
                    cellValues?.row?.in_shopify &&
                    cellValues?.row?.update_product_shopify &&
                    "green",
                }}
                //  onClick={() => uploadProductOnWordpress(cellValues?.row?._id)}
                disabled={
                  cellValues?.row?.in_shopify &&
                  !cellValues?.row?.update_product_shopify
                }
              >
                {cellValues?.row.in_shopify &&
                cellValues?.row?.update_product_shopify
                  ? "Update on shopify"
                  : "Upload on shopify"}
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
      
    },
    {
      field: "delete_wordpress",
      headerName: "Delete Wordpress",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div>
            <Popconfirm
              title="Delete"
              description="Are you sure to delete on wordpress?"
              onConfirm={() => deleteProductOnWordpress(cellValues?.row?._id)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button disabled={!cellValues?.row?.in_wordpress}>
                {" "}
                Delete From Wordpress
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
    },
    {
      field: "delete_shopify",
      headerName: "Delete Shopify",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div>
            <Popconfirm
              title="Delete"
              description="Are you sure to delete on shopify?"
              onConfirm={() => deleteProductOnShopify(cellValues?.row?._id)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button disabled={!cellValues?.row?.in_shopify}>
                {" "}
                Delete From Shopify
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
    },
    {
      field: "department",
      headerName: "Department",
      headerClassName: "super-app-theme--header",
      width: "150",
    },
    {
      field: "category",
      headerName: "Category",
      headerClassName: "super-app-theme--header",
      width: "150",
    },
    {
      field: "sub_category",
      headerName: "Subcategory",
      headerClassName: "super-app-theme--header",
      width: "150",
    },
    {
      field: "make",
      headerName: "Make",
      headerClassName: "super-app-theme--header",
      width: "150",
    },
    {
      field: "model",
      headerName: "Model",
      headerClassName: "super-app-theme--header",
      width: "150",
    },
    {
      field: "product_color",
      headerName: "Color",
      headerClassName: "super-app-theme--header",
      width: "150",
    },

    {
      field: "IMEI",
      headerName: "IMEI",
      headerClassName: "super-app-theme--header",
      width: "150",
      renderCell: (cellValues) => {
        return <p>{cellValues?.row?.IMEI ? cellValues?.row?.IMEI : "-"}</p>;
      },
    },

    {
      field: "status",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      width: "150",
      renderCell: (cellValues) => {
        return (
          <p
            style={{
              color:
                cellValues.value == "Active"
                  ? Colors.green
                  : cellValues.value == "Restock"
                  ? "#DC9E00"
                  : cellValues?.value == "Out Of Stock"
                  ? Colors.red
                  : "purple",
              fontFamily: "Poppins",
              fontWeight: "bold",
            }}
          >
            {cellValues?.value}
          </p>
        );
      },
    },
 {
          field: "created_at",
          headerName: "Create At",
          headerClassName: "super-app-theme--header",
          width: "150",
          renderCell: (cellValues) => {
            return (
              <p
              >
                {moment(cellValues?.value).format("DD/MM/YYYY")}
              </p>
            );
          },
        },
    {
      field: "product_description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      width: "150",
      renderCell: (cellValues) => {
        return (
          <CustomButton
            onClick={() => handleOpenDescriptionModal(cellValues?.row)}
            text={"Show Description"}
            style={{ width: 200, padding: 1, borderRadius: 1, fontSize: 12 }}
          />
        );
      },
    },
  ]);

    useEffect(() => {
      axios.get(`${Base_Uri}getcollectionshopify`).then((data) => {
        setAllCollections(data.data);
        
      });
     
    }, []);

 

  useEffect(() => {
    if (userData && userData?.role !== "admin") {
      let roleAccess = userData?.role_access;

      let stockBooking =
        roleAccess &&
        roleAccess?.length > 0 &&
        roleAccess?.find((e) => e.name == "ShowCostPrice" && e?.selected);
      let in_wordpress =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "in_wordpress" && sub.selected
            )
        );
      let in_shopify =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "in_shopify" && sub.selected
            )
        );
      let delete_wordpress =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "delete_wordpress" && sub.selected
            )
        );
      let delete_shopify =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "delete_shopify" && sub.selected
            )
        );
      let DiamondPriceAd =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "DiamondPrice" && sub.selected
            )
        );
      let PlatinumPriceAd =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "PlatinumPrice" && sub.selected
            )
        );
      let GoldPriceAd =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "GoldPrice" && sub.selected
            )
        );
      let RetailPriceAd =
        userData?.role_access?.length != 0 &&
        userData.role_access?.some(
          (role) =>
            role?.subcategory &&
            role?.subcategory?.some(
              (sub) => sub.name === "RetailPrice" && sub.selected
            )
        );
      let userAccess = [];
      if (!stockBooking) {
        userAccess.push("cost_price");
      }
      if (!DiamondPriceAd) {
        userAccess.push("diamond");
      }
      if (!PlatinumPriceAd) {
        userAccess.push("trade_price");
      }
      if (!GoldPriceAd) {
        userAccess.push("warehouse_price");
      }
      if (!RetailPriceAd) {
        userAccess.push("retail_price");
      }
      if (!in_wordpress) {
        userAccess.push("in_wordpress");
      }
      if (!in_shopify) {
        userAccess.push("in_shopify");
      }
      if (!delete_shopify) {
        userAccess.push("delete_shopify");
      }
      if (!delete_wordpress) {
        userAccess.push("delete_wordpress");
      }

      // if (stockBooking?.selected) {
      const columns = [
        

        {
          field: "barcode",
          headerName: "Barcode",
          width: "130",
          headerClassName: "super-app-theme--header",
        },
        {
      field: "sku",
      headerName: "SKU",
      width: "100",
      headerClassName: "super-app-theme--header",
    },
        {
      field: "images",
      headerName: "Image",
      width: "80",
      headerClassName: "super-app-theme--header",
      renderCell: (cellValues) => {
  const { image1_url, image2_url, image3_url } = cellValues?.row || {};

  const images = [image1_url, image2_url, image3_url]
    .map(getImageUrl)
    .filter(Boolean); // remove null/undefined

  if (!images.length) {
    return (
      <img
        src="https://demofree.sirv.com/nope-not-here.jpg"
        style={{ height: 60, width: 80 }}
      />
    );
  }

  return (
    <Image.PreviewGroup>
      {/* show only first image */}
      <Image
        src={images[0]}
        style={{ height: 60, width: 80, objectFit: "cover" }}
        preview={{ visible: false }}
      />

      {/* hidden images but included in preview */}
      {images.slice(1).map((img, i) => (
        <Image key={i} src={img} style={{ display: "none" }} />
      ))}
    </Image.PreviewGroup>
  )
}
    },
        {
          field: "product_name",
          headerName: "Product Name",
          headerClassName: "super-app-theme--header",
          minWidth: "600",
        },

        {
          field: "qty",
          headerClassName: "super-app-theme--header",
          headerName: "Quantity",
          width: "120",
        },
        {
          field: "cost_price",
          headerClassName: "super-app-theme--header",
          headerName: "Cost",
          width: "120",
          renderCell: (cellValues) => {
            return <p>{Number(cellValues?.row?.cost_price).toFixed(2)}</p>;
          },
        },
        {
          field: "diamond",
          headerClassName: "super-app-theme--header",
          headerName: "Diamond",
          width: "120",
          renderCell: (cellValues) => {
            return <p>{Number(cellValues?.row?.diamond).toFixed(2)}</p>;
          },
        },
        {
          field: "trade_price",
          headerName: "Platinum",
          headerClassName: "super-app-theme--header",
          width: "120",
          renderCell: (cellValues) => {
            return <p>{Number(cellValues?.row?.trade_price).toFixed(2)}</p>;
          },
        },
        {
          field: "warehouse_price",
          headerName: "Gold",
          headerClassName: "super-app-theme--header",
          width: "120",
          renderCell: (cellValues) => {
            return <p>{Number(cellValues?.row?.warehouse_price).toFixed(2)}</p>;
          },
        },

        {
          field: "retail_price",
          headerName: "Retail",
          headerClassName: "super-app-theme--header",
          width: "120",
          renderCell: (cellValues) => {
            return <p>{Number(cellValues?.row?.retail_price).toFixed(2)}</p>;
          },
        },
        {
          field: "compatibility",
          headerName: "Compatibility",
          headerClassName: "super-app-theme--header",
          width: 300,
          renderCell: (cellValues) => {
            return (
              <p>
                {cellValues?.row?.compatibility
                  ? cellValues?.row?.compatibility
                  : "-"}
              </p>
            );
          },
        },
        {
      field: "in_wordpress",
      headerName: "In Wordpress",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div>
            <Popconfirm
              title={
                cellValues?.row?.in_wordpress &&
                cellValues?.row?.update_product_wordpress
                  ? "Update"
                  : "Upload"
              }
              description={
                <div>
                  <div>
                    Are you sure to{" "}
                    {cellValues?.row?.in_wordpress &&
                    cellValues?.row?.update_product_wordpress
                      ? "Update"
                      : "Upload"}{" "}
                    on wordpress?
                  </div>
                  <Select
                    defaultValue="wp"
                    onChange={(e) => setSelectPriceStatus(e)}
                    options={[
                      { value: "cp", label: "Cost" },
                      { value: "di", label: "Diamond" },
                      { value: "tp", label: "Platinum" },
                      { value: "wp", label: "Gold" },
                      { value: "rp", label: "Retail" },
                    ]}
                  />
                </div>
              }
              a
              onConfirm={() =>
                cellValues?.row?.in_wordpress &&
                cellValues?.row?.update_product_wordpress
                  ? updateProductOnWordpress(cellValues?.row?._id)
                  : uploadProductOnWordpress(cellValues?.row?._id)
              }
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  color:
                    cellValues?.row?.in_wordpress &&
                    cellValues?.row?.update_product_wordpress &&
                    "green",
                }}
                //  onClick={() => uploadProductOnWordpress(cellValues?.row?._id)}
                disabled={
                  cellValues?.row?.in_wordpress &&
                  !cellValues?.row?.update_product_wordpress
                }
              >
                {cellValues?.row.in_wordpress &&
                cellValues?.row?.update_product_wordpress
                  ? "Update on wordpress"
                  : "Upload on Wordpress"}
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
    },
    {
      field: "in_shopify",
      headerName: "In Shopify",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div >
            <Popconfirm
              title={
                cellValues?.row?.in_shopify &&
                cellValues?.row?.update_product_shopify
                  ? "Update"
                  : "Upload"
              }
              description={
                <div onClick={(e) => e.stopPropagation()}>
                  <div>
                    Are you sure to{" "}
                    {cellValues?.row?.in_shopify &&
                    cellValues?.row?.update_product_shopify
                      ? "Update"
                      : "Upload"}{" "}
                    on shopify?
                  </div>
                  <Select
                    defaultValue="tp"
                    onChange={(e) => setSelectPriceStatus(e)}
                    options={[
                      { value: "cp", label: "Cost" },
                      { value: "di", label: "Diamond" },
                      { value: "tp", label: "Platinum" },
                      { value: "wp", label: "Gold" },
                      { value: "rp", label: "Retail" },
                    ]}
                  />
                  <Select
                placeholder={"Select Collections"}
                style={{width:200}}
                // value={selectedCollections}
                // onClick={(e)=>e.stopPropagation()}
                  onChange={(e) => {
                    setSelectedCollections(e)
                    
                    // console.log(e,"lk")
                  }}
                  options={[
  { label: "Apple", value:"653084557639" },
  { label: "Batteries", value:"651312529735" },
  { label: "Batteries, Samsung Parts", value:"653060145479" },
  { label: "Camera Lens & Sensors", value:"651315249479" },
  { label: "Charging Board", value:"651942396231" },
  { label: "Charging Ports / Flex Cables", value:"651315151175" },
  { label: "Console Parts", value:"651455529287" },
  { label: "Featured", value:"651462738247" },
  { label: "Google", value:"651888656711" },
  { label: "Home page", value:"648078819655" },
  { label: "iphone 17 pro max", value:"652896928071" },
  { label: "LCD Screens", value:"653060211015" },
  { label: "LCD Screens, Samsung Parts", value:"653060047175" },
  { label: "Phone Accessories & Repair Parts", value:"651315446087" },
  { label: "Phone Screens & LCDs", value:"651314954567" },
  { label: "Sim Tray", value:"652461474119" }
]}
                />
               
                </div>
              }
              
              onConfirm={() =>
                cellValues?.row?.in_shopify &&
                cellValues?.row?.update_product_shopify
                  ? updateProductOnWordpress(cellValues?.row?._id)
                  : uploadProductOnShopify(cellValues?.row?._id)
              }
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button
                style={{
                  color:
                    cellValues?.row?.in_shopify &&
                    cellValues?.row?.update_product_shopify &&
                    "green",
                }}
                //  onClick={() => uploadProductOnWordpress(cellValues?.row?._id)}
                disabled={
                  cellValues?.row?.in_shopify &&
                  !cellValues?.row?.update_product_shopify
                }
              >
                {cellValues?.row.in_shopify &&
                cellValues?.row?.update_product_shopify
                  ? "Update on shopify"
                  : "Upload on shopify"}
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
      
    },
    {
      field: "delete_wordpress",
      headerName: "Delete Wordpress",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div>
            <Popconfirm
              title="Delete"
              description="Are you sure to delete on wordpress?"
              onConfirm={() => deleteProductOnWordpress(cellValues?.row?._id)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button disabled={!cellValues?.row?.in_wordpress}>
                {" "}
                Delete From Wordpress
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
    },
    {
      field: "delete_shopify",
      headerName: "Delete Shopify",
      headerClassName: "super-app-theme--header",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div>
            <Popconfirm
              title="Delete"
              description="Are you sure to delete on shopify?"
              onConfirm={() => deleteProductOnShopify(cellValues?.row?._id)}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button disabled={!cellValues?.row?.in_shopify}>
                {" "}
                Delete From Shopify
              </Button>
            </Popconfirm>
            {/* <Button onClick={() => uploadProductOnWordpress(cellValues?.row?._id)} disabled={cellValues?.row?.in_wordpress}>Delete From Wordpress</Button> */}
            {/* <p>{cellValues?.row?.in_wordpress ? <div style={{color:"green"}}>YES</div> : <div style={{color:"red"}}>NO</div>}</p> */}
          </div>
        );
      },
    },
        {
          field: "department",
          headerName: "Department",
          headerClassName: "super-app-theme--header",
          width: "150",
        },
        {
          field: "category",
          headerName: "Category",
          headerClassName: "super-app-theme--header",
          width: "150",
        },
        {
          field: "sub_category",
          headerName: "Subcategory",
          headerClassName: "super-app-theme--header",
          width: "150",
        },
        {
          field: "make",
          headerName: "Make",
          headerClassName: "super-app-theme--header",
          width: "150",
        },
        {
          field: "model",
          headerName: "Model",
          headerClassName: "super-app-theme--header",
          width: "150",
        },
        {
          field: "product_color",
          headerName: "Color",
          headerClassName: "super-app-theme--header",
          width: "150",
        },

        {
          field: "IMEI",
          headerName: "IMEI",
          headerClassName: "super-app-theme--header",
          width: "150",
          renderCell: (cellValues) => {
            return <p>{cellValues?.row?.IMEI ? cellValues?.row?.IMEI : "-"}</p>;
          },
        },

        {
          field: "status",
          headerName: "Status",
          headerClassName: "super-app-theme--header",
          width: "150",
          renderCell: (cellValues) => {
            return (
              <p
                style={{
                  color:
                    cellValues.value == "Active"
                      ? Colors.green
                      : cellValues.value == "Restock"
                      ? "#DC9E00"
                      : cellValues?.value == "Out Of Stock"
                      ? Colors.red
                      : "purple",
                  fontFamily: "Poppins",
                  fontWeight: "bold",
                }}
              >
                {cellValues?.value}
              </p>
            );
          },
        },
        {
          field: "created_at",
          headerName: "Create At",
          headerClassName: "super-app-theme--header",
          width: "150",
          renderCell: (cellValues) => {
            return (
              <p
              >
                {moment(cellValues?.value).format("DD/MM/YYYY")}
              </p>
            );
          },
        },

        {
          field: "product_description",
          headerName: "Description",
          headerClassName: "super-app-theme--header",
          width: "150",
          renderCell: (cellValues) => {
            return (
              <CustomButton
                onClick={() => handleOpenDescriptionModal(cellValues?.row)}
                text={"Show Description"}
                style={{
                  width: 200,
                  padding: 1,
                  borderRadius: 1,
                  fontSize: 12,
                }}
              />
            );
          },
        },
      ];
      const filteredColumns = columns.filter(
        (col) => !userAccess.includes(col.field)
      );
      setColumn(filteredColumns);
      // }
    }
  }, [userData]);

  const getProducts = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getProducts`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let myData = res.data;

        let { data } = myData;

        if (data && data.length > 0) {
          let allProducts = [];

          for (var i = 0; i < data.length; i++) {
            let product = data[i];

            product.id = i + 1;
            product["productName"] = product?.product_name;

            if (product.status == "active") {
              product.status = "Active";
            }

            if (product?.qty <= product?.reminder_qty) {
              product.status = "Restock";
            }

            allProducts.push(product);
          }

          setProducts(allProducts);
          dispatch(updateProducts(allProducts));
        }
      })
      .catch((error) => {
        // console.log(error, "error");
        // setLoading(false)
      });
  };

  useEffect(() => {
    // getProducts();
  }, []);

  // useEffect(() => {
    
  //   let category =
  //     product &&
  //     product?.length > 0 &&
  //     product.map((e, i) => {
  //       return e.category;
  //     });
  //   if (category) {
  //     category = [...new Set(category)];
  //     category.unshift("All Categories");
  //     setCategory(category);
  //   }
  // }, [product.length]);
  // useEffect(() => {
  //   let category =
  //     product &&
  //     product?.length > 0 &&
  //     product.map((e, i) => {
  //       return e.department;
  //     });
  //   if (category) {
  //     category = [...new Set(category)];
  //     category.unshift("All Departments");
  //     setDepartment(category);
  //   }
  // }, [product.length]);

  useEffect(()=>{
const func = async()=>{
  let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;
    let categories =    await axios
                  .get(`${Base_Uri}getProductDepartment`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json", // Include other headers as needed
                    },
                  })
                  // console.log(categories.data.data)
const departments = [
  "All Departments",
  ...Array.from(
      new Set(categories.data.data?.map(e => e.departmentName))
    ).sort()
];

const categoriesList = categories.data.data
  ?.flatMap(e => e.categories?.map(j => j.categoryName)) || [];

const categoriesUniqueSorted = [
  "All Categories",
  ...Array.from(new Set(categoriesList)).sort()
];

setCategory(categoriesUniqueSorted);
setDepartment(departments)
}
func()
  },[])

  const selectProduct = (id) => {
    setProducts(
      product.map((e, i) => {
        if (e.id == id) {
          return {
            ...e,
            selected: !e?.selected,
          };
        } else {
          return e;
        }
      })
    );
  };

  // const selectAllProduct = () => {
  //     setSelectAll({
  //         ...selectAll,
  //         selected: !selectAll.selected
  //     })

  //     setProducts(product.map((e, i) => {
  //         return {
  //             ...e,
  //             selected: selectAll ? false : true
  //         }
  //     }))

  // }

//   useEffect(()=>{
// if (searchCategory.length<0) {
//   // console.log(searchCategory,"ld")
//   fetchProducts(1, 20)
// }
// // console.log(rows,"l")
//   },[searchCategory])


  const [selectedCategory, setSelectedCategory] = useState("select");
  const [selectedDepartment, setSelectedDepartment] = useState("select");
  const handleSelectionModelChange = (selectionModel) => {
    console.log(selectionModel, "selectionModel","rows");
    // console.log(selectionModel, "selectionModel",searchCategory,"rows");

    if (selectionModel&&selectionModel?.length > 0) {
      selectionModel = selectedItemsIds
        ? selectionModel.length > 1
          ? selectionModel[1]
          : selectionModel[0]
        : selectionModel;
      setProducts(
        rows && rows.length > 0
          ? rows.map((e) => {
              if (selectionModel == e?._id) {
                return {
                  ...e,
                  selected: true,
                };
              } else {
                return {
                  ...e,
                  selected: false,
                };
              }
            })
          : []
      );
      // setSearchCategory(
      //   searchCategory && searchCategory.length > 0
      //     ? searchCategory?.map((e) => {
      //         if (selectionModel == e?.id) {
      //           return {
      //             ...e,
      //             selected: true,
      //           };
      //         } else {
      //           return {
      //             ...e,
      //             selected: false,
      //           };
      //         }
      //       })
      //     : []
      // );
      setRows(  rows && rows.length > 0
        ? rows.map((e) => {
            if (selectionModel == e?._id) {
              return {
                ...e,
                selected: true,
              };
            } else {
              return {
                ...e,
                selected: false,
              };
            }
          })
        : [])
    } else {
      setProducts(
        product &&
          product?.length > 0 &&
          product.map((e, i) => {
            return {
              ...e,
              selected: false,
            };
          })
      );
      setRows(
        rows &&
          rows?.length > 0 &&
          rows.map((e, i) => {
            return {
              ...e,
              selected: false,
            };
          })
      )
      // setSearchCategory(
      //   searchCategory &&
      //     searchCategory?.length > 0 &&
      //     searchCategory?.map((e, i) => {
      //       return {
      //         ...e,
      //         selected: false,
      //       };
      //     })
      // )
    }
  };
const [selectedIds, setSelectedIds] = useState([]);
const handleMultipleSelectionModelChange = (selectionModel) => {
  setSelectedIds(selectionModel);

  setRows((prev) =>
    prev.map((row) => ({
      ...row,
      selected: selectionModel.includes(row._id),
    }))
  );

  setProducts((prev) =>
    prev.map((p) => ({
      ...p,
      selected: selectionModel.includes(p._id),
    }))
  );
};
const DeleteAllProducts = async(type="ids")=>{
  setLoading(true)
  let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      // console.log(token,"token")
      axios
        .delete(`${Base_Uri}deleteproducts`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data:{products:type=="barcode"?barcodeBulkList:selectedIds,type:type}
        })
        .then(async (res) => {
          // console.log(res.data, "ldldl");
          let data = res.data;

          if (data?.status) {
            message.info("Products deleted successfully")
            // console.log(data)
            let productss
            if (type=="ids") {
               productss = await rows.filter(
  (p) => !selectedIds.includes(p.id)
);
            }
            if (type=="barcode") {
               productss = await rows.filter(
  (p) => !selectedIds.includes(p.barcode)
);
            }
//console.log(productss,"productss")
//console.log(rows,"rows")

setProducts(productss);
setRows(productss);
setSelectedIds([]);
setBarcodeBulkList([])
setIsModalOpen2(false)
          }
          setLoading(false)
        }).catch((err)=>{
          //console.log(err)
          setLoading(false)
          message.info("Products not deleted try again")
        })
}
//   const handleMultipleSelectionModelChange = (newSelection) => {
//   console.log(newSelection,"newSelection")
//   setSelectedIds((prevSelected) => {
//     let updatedSelection = [...prevSelected];

//     newSelection.forEach((id) => {
//       if (prevSelected.includes(id)) {
//         // already selected → deselect
//         updatedSelection = updatedSelection.filter((x) => x !== id);
//       } else {
//         // not selected → select
//         updatedSelection.push(id);
//       }
//     });

//     // update rows
//     setRows((prev) =>
//       prev.map((row) => ({
//         ...row,
//         selected: updatedSelection.includes(row._id),
//       }))
//     );

//     // update products
//     setProducts((prev) =>
//       prev.map((p) => ({
//         ...p,
//         selected: updatedSelection.includes(p._id),
//       }))
//     );

//     return updatedSelection;
//   });
// };

  
  const [checkAdminData, setCheckAdminData] = useState({});
  useEffect(() => {
    const func = async () => {
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .get(`${Base_Uri}getAllEmployees?singleuser=1`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // console.log(res.data, "ldldl");
          let data = res.data;

          if (data?.status) {
            // // console.log(data.data[0].role_access.filter((CA) =>  (CA.name == "StockBooking"))[0].subcategory.filter((Cc) => Cc.name == "Delete Products")[0].selected)
            setCheckAdminData(data.data[0]);
          }
        });
    };
    func();
  }, []);

  const handleDeleteProducts = async () => {
    let deleteProducts = product.filter((e, i) => e.selected);

    let otherProducts =
      product && product.length > 0 && product.filter((e, i) => !e?.selected);

    if (deleteProducts && deleteProducts.length > 0) {
      setLoader({
        ...loader,
        delete: true,
      });

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .get(`${Base_Uri}getAllEmployees`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          let data = res.data;

          if (data?.status) {
          }
        });
      axios
        .delete(`${Base_Uri}deleteproducts`, {
          data: {products:deleteProducts.map((e)=>e?._id),type:"ids"},
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (data.status) {
            let productsToSend =
              otherProducts &&
              otherProducts.length > 0 &&
              otherProducts.map((e, i) => {
                return {
                  ...e,
                  id: i + 1,
                  selected: false,
                };
              });

            setProducts(productsToSend);
            dispatch(updateProducts(productsToSend));
            setSelectedRows([]);
            setGridKey(gridKey + 1);
            message.info(data.message);

            setLoader({
              ...loader,
              delete: false,
            });
          } else {
            message.info(data.message);
            setLoader({
              ...loader,
              delete: false,
            });
          }
        })
        .catch((error) => {
          setLoader({
            ...loader,
            delete: false,
          });
          message.info("sorry there is a server error in deleting the products");
        });
    }
  };

  const handleActiveProducts = async () => {
    let selectedProducts =
      product && product.length > 0 && product.filter((e, i) => e.selected);

    if (selectedProducts && selectedProducts.length > 0) {
      selectedProducts = selectedProducts.map((e, i) => {
        return {
          ...e,
          status: "Active",
        };
      });

      try {
        setLoader({
          ...loader,
          active: true,
        });

        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        const response = await axios.put(
          `${Base_Uri}changeProductStatus`,
          selectedProducts,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        // Handle the response here
        let res = response.data;

        if (!res.status) {
          message.info(res.message);
          setLoader({
            ...loader,
            active: false,
          });
        } else {
          let updatedProducts =
            product &&
            product.length > 0 &&
            product.map((e, i) => {
              if (e.selected) {
                return {
                  ...e,
                  status: "Active",
                };
              } else {
                return e;
              }
            });

          setProducts(updatedProducts);
          dispatch(updateProducts(updatedProducts));
          setGridKey(gridKey + 1);
          setSelectedRows([]);
          message.info(res.message);

          setLoader({
            ...loader,
            active: false,
          });
        }

        // If you want to update the state based on the API response, you can do something like:
        // setProducts(updatedProducts);
      } catch (error) {
        // Handle errors here
        console.error("Error:", error);

        message.info(error.message);
      }
    } else {
      message.info("Kindly select product");
    }
  };

  const handleInActiveProducts = async () => {
    let selectedProducts =
      product && product.length > 0 && product.filter((e, i) => e.selected);

    if (selectedProducts && selectedProducts.length > 0) {
      selectedProducts = selectedProducts.map((e, i) => {
        return {
          ...e,
          status: "Inactive",
        };
      });

      try {
        setLoader({
          ...loader,
          inactive: true,
        });

        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        const response = await axios.put(
          `${Base_Uri}changeProductStatus`,
          selectedProducts,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        // Handle the response here
        let res = response.data;

        if (!res.status) {
          message.info(res.message);
          setLoader({
            ...loader,
            inactive: false,
          });
        } else {
          let updatedProducts =
            product &&
            product.length > 0 &&
            product.map((e, i) => {
              if (e.selected) {
                return {
                  ...e,
                  status: "Inactive",
                };
              } else {
                return e;
              }
            });

          setProducts(updatedProducts);
          dispatch(updateProducts(updatedProducts));
          setGridKey(gridKey + 1);
          setSelectedRows([]);
          message.info(res.message);

          setLoader({
            ...loader,
            inactive: false,
          });
        }

        // If you want to update the state based on the API response, you can do something like:
        // setProducts(updatedProducts);
      } catch (error) {
        // Handle errors here
        console.error("Error:", error);

        message.info(error.message);
      }
    } else {
      message.info("Kindly select product");
    }
  };

  const handleFilterCategory = (name) => {
    setSelectedCategory(name);
    setPaginationModel({ page: 0, pageSize: 20 })

    // if (filter.active && name == "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Active";
    //       })
    //   );
    // } else if (filter.restock && name == "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Restock" || e.status == "Out Of Stock";
    //       })
    //   );
    // } else if (filter.inactive && name == "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status.toLowerCase() == "inactive";
    //       })
    //   );
    // } else if (
    //   !filter.active &&
    //   !filter.restock &&
    //   !filter?.inactive &&
    //   name == "All Categories"
    // ) {
    //   setSearchCategory([]);
    // } else if (filter.active && name !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Active" && e.category == name;
    //       })
    //   );
    // } else if (filter.restock && name !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return (
    //           (e.status.toLowerCase() == "restock" ||
    //             e.status == "Out Of Stock") &&
    //           e.category == name
    //         );
    //       })
    //   );
    // } else if (filter.inactive && name !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status.toLowerCase() == "inactive" && e.category == name;
    //       })
    //   );
    // } else {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.category == name;
    //       })
    //   );
    // }
  };
  const handleFilterDepartment = async(name) => {
    setSelectedDepartment(name);
    // fetchProducts(1,20)
    setPaginationModel({ page: 0, pageSize: 20 })

    // if (filter.active && name == "All Departments") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Active";
    //       })
    //   );
    // } else if (filter.restock && name == "All Departments") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Restock" || e.status == "Out Of Stock";
    //       })
    //   );
    // } else if (filter.inactive && name == "All Departments") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status.toLowerCase() == "inactive";
    //       })
    //   );
    // } else if (
    //   !filter.active &&
    //   !filter.restock &&
    //   !filter?.inactive &&
    //   name == "All Departments"
    // ) {
    //   setSearchCategory([]);
    // } else if (filter.active && name !== "All Departments") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Active" && e.department == name;
    //       })
    //   );
    // } else if (filter.restock && name !== "All Departments") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return (
    //           (e.status.toLowerCase() == "restock" ||
    //             e.status == "Out Of Stock") &&
    //           e.department == name
    //         );
    //       })
    //   );
    // } else if (filter.inactive && name !== "All Departments") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status.toLowerCase() == "inactive" && e.department == name;
    //       })
    //   );
    // } else {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.department == name;
    //       })
    //   );
    // }
  };
  // console.log(searchCategory)

  const filterRestockProduct = () => {
    setFilter({
      ...filter,
      restock: !filter.restock,
      active: false,
      inactive: false,
      all: false,
    });
//  setPaginationModel({ page: 0, pageSize: 20 })
    if (filter.restock && selectedCategory == "All Categories") {
      setSearchCategory([]);
      return;
    }

    if (filter.restock && selectedCategory !== "All Categories") {
      setSearchCategory(
        product &&
          product.length > 0 &&
          product.filter((e, i) => {
            return e.category == selectedCategory;
          })
      );

      return;
    }

    if (
      !filter.restock &&
      (selectedCategory == "All Categories" || selectedCategory == "select")
    ) {
      setSearchCategory(
        product &&
          product.length > 0 &&
          product.filter((e, i) => {
            return e.status == "Restock" || e.status == "Out Of Stock";
          })
      );
      return;
    }

    if (!filter.restock && selectedCategory !== "All Categories") {
      setSearchCategory(
        product &&
          product.length > 0 &&
          product.filter((e, i) => {
            return (
              e.category == selectedCategory &&
              (e.status == "Restock" || e.status == "Out Of Stock")
            );
          })
      );

      return;
    }

    if (selectedCategory !== "select") {
      setSearchCategory(
        product &&
          product.length > 0 &&
          product.filter((e, i) => {
            return (
              (e.status == "Restock" || e.status == "Out Of Stock") &&
              e.category == selectedCategory
            );
          })
      );
    
      return;
    }

    setSearchCategory(
      product &&
        product.length > 0 &&
        product.filter((e, i) => {
          return e.status == "Restock" || e.status == "Out Of Stock";
        })
    );
    // // console.log(  product &&
    //     product.length > 0 &&
    //     product.filter((e, i) => {
    //       return e.status == "Restock" || e.status == "Out Of Stock";
    //     }))
  };

  const filterActiveProduct = () => {
    setFilter({
      ...filter,
      restock: false,
      active: !filter.active,
      inactive: false,
      all: false,
    });
    setPaginationModel({ page: 0, pageSize: 20 })
    

    // if (filter.active && selectedCategory == "All Categories") {
    //   setSearchCategory([]);
    //   return;
    // }

    // if (filter.active && selectedCategory !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.category == selectedCategory;
    //       })
    //   );

    //   return;
    // }

    // if (
    //   !filter.active &&
    //   (selectedCategory == "All Categories" || selectedCategory == "select")
    // ) {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Active";
    //       })
    //   );
    //   return;
    // }

    // if (!filter.active && selectedCategory !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.category == selectedCategory && e.status == "Active";
    //       })
    //   );

    //   return;
    // }

    // if (selectedCategory !== "select") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Active" && e.category == selectedCategory;
    //       })
    //   );
    //   return;
    // }

    // setSearchCategory(
    //   product &&
    //     product.length > 0 &&
    //     product.filter((e, i) => {
    //       return e.status == "Active";
    //     })
    // );
  };

  // const filterActiveProduct = () => {

  //     setFilter({
  //         ...filter,
  //         restock: false,
  //         active: !filter.active,
  //         inactive: false,
  //         all: false
  //     })

  //     if (filter.active && selectedCategory == "All Categories") {
  //         setSearchCategory([])
  //         return
  //     }

  //     if (filter.active && selectedCategory !== "All Categories") {
  //         setSearchCategory(product && product.length > 0 && product.filter((e, i) => {
  //             return e.category == selectedCategory
  //         }))

  //         return
  //     }
  //     if (selectedCategory !== "select") {
  //         setSearchCategory(product && product.length > 0 && product.filter((e, i) => {
  //             return e.status == "Active" && e.category == selectedCategory
  //         }))
  //         return
  //     }
  //     setSearchCategory(product && product.length > 0 && product.filter((e, i) => {
  //         return e.status == "Active"
  //     }))

  // }

  const filterInactiveProduct = () => {
    setFilter({
      ...filter,
      restock: false,
      active: false,
      inactive: !filter.inactive,
      all: false,
    });
  setPaginationModel({ page: 0, pageSize: 20 })
    // if (filter.inactive && selectedCategory == "All Categories") {
    //   setSearchCategory([]);
    //   return;
    // }

    // if (filter.inactive && selectedCategory !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.category == selectedCategory;
    //       })
    //   );

    //   return;
    // }

    // if (
    //   !filter.inactive &&
    //   (selectedCategory == "All Categories" || selectedCategory == "select")
    // ) {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Inactive";
    //       })
    //   );
    //   return;
    // }

    // if (!filter.inactive && selectedCategory !== "All Categories") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.category == selectedCategory && e.status == "Inactive";
    //       })
    //   );

    //   return;
    // }

    // if (selectedCategory !== "select") {
    //   setSearchCategory(
    //     product &&
    //       product.length > 0 &&
    //       product.filter((e, i) => {
    //         return e.status == "Inactive" && e.category == selectedCategory;
    //       })
    //   );
    //   return;
    // }

    // setSearchCategory(
    //   product &&
    //     product.length > 0 &&
    //     product.filter((e, i) => {
    //       return e.status == "Inactive";
    //     })
    // );
  
  };

  // const filterInactiveProduct = () => {

  //     setFilter({
  //         ...filter,
  //         restock: false,
  //         active: false,
  //         inactive: !filter.inactive,
  //         all: false
  //     })

  //     if (filter.inactive && selectedCategory == "All Categories") {
  //         setSearchCategory([])
  //         return
  //     }

  //     if (filter.active && selectedCategory !== "All Categories") {
  //         setSearchCategory(product && product.length > 0 && product.filter((e, i) => {
  //             return e.category == selectedCategory
  //         }))

  //         return
  //     }

  //     if (selectedCategory !== "select") {
  //         setSearchCategory(product && product.length > 0 && product.filter((e, i) => {
  //             return e.status == "Inactive" && e.category == selectedCategory
  //         }))
  //         return
  //     }
  //     setSearchCategory(product && product.length > 0 && product.filter((e, i) => {
  //         return e.status == "Inactive"
  //     }))

  // }

  // const handleSearchProducts = (e) => {
  //   let value = e.target.value;

  //   if (
  //     !filter.active &&
  //     !filter.inactive &&
  //     !filter.restock &&
  //     (selectedCategory == "All Categories" || selectedCategory == "select")
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e) => {
  //           return (
  //             (e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //             (e.barcode
  //               ?.toString()
  //               .toLowerCase()
  //               .includes(value.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //             (e.sku?.toLowerCase().includes(value.toLowerCase())) ||
  //             (e.color?.toLowerCase().includes(value.toLowerCase()))
  //           );
  //         })
  //     );

  //     return;
  //   }

  //   if (
  //     filter.active &&
  //     (selectedCategory == "All Categories" || selectedCategory == "select")
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e, i) => {
  //           return (
  //             ((e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.sku?.toLowerCase()?.includes(value?.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //              ( e?.barcode
  //                 ?.toString()
  //                 ?.toLowerCase()
  //                 ?.includes(value?.toString()?.toLowerCase()))) &&
  //             e.status == "Active"
  //           );
  //         })
  //     );
  //     return;
  //   }

  //   if (
  //     filter.inactive &&
  //     (selectedCategory == "All Categories" || selectedCategory == "select")
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e, i) => {
  //           return (
  //             ((e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.sku?.toLowerCase()?.includes(value?.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.barcode
  //                 ?.toString()
  //                 ?.toLowerCase()
  //                 ?.includes(value?.toString()?.toLowerCase()))) &&
  //             e.status == "Inactive"
  //           );
  //         })
  //     );
  //     return;
  //   }

  //   if (
  //     filter.restock &&
  //     (selectedCategory == "All Categories" || selectedCategory == "select")
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e, i) => {
  //           return (
  //             ((e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.sku?.toLowerCase()?.includes(value?.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.barcode
  //                 ?.toString()
  //                 ?.toLowerCase()
  //                 ?.includes(value?.toString()?.toLowerCase()))) &&
  //             (e.status == "Restock" || e.status == "Out Of Stock")
  //           );
  //         })
  //     );
  //     return;
  //   }

  //   if (
  //     filter.active &&
  //     selectedCategory !== "All Categories" &&
  //     selectedCategory !== "select"
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e, i) => {
  //           return (
  //             ((e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.sku?.toLowerCase()?.includes(value?.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.barcode
  //                 ?.toString()
  //                 ?.toLowerCase()
  //                 ?.includes(value?.toString()?.toLowerCase()))) &&
  //             e.status == "Active" &&
  //             e.category == selectedCategory
  //           );
  //         })
  //     );
  //     return;
  //   }

  //   if (
  //     filter.inactive &&
  //     selectedCategory !== "All Categories" &&
  //     selectedCategory !== "select"
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e, i) => {
  //           return (
  //             ((e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.sku?.toLowerCase()?.includes(value?.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.barcode
  //                 ?.toString()
  //                 ?.toLowerCase()
  //                 ?.includes(value?.toString()?.toLowerCase()))) &&
  //             e.status == "Inactive" &&
  //             e.category == selectedCategory
  //           );
  //         })
  //     );
  //     return;
  //   }

  //   if (
  //     filter.restock &&
  //     selectedCategory !== "All Categories" &&
  //     selectedCategory !== "select"
  //   ) {
  //     setSearchCategory(
  //       product &&
  //         product.length > 0 &&
  //         product.filter((e, i) => {
  //           return (
  //             ((e.productName.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.sku?.toLowerCase()?.includes(value?.toLowerCase())) ||
  //               (e.color?.toLowerCase().includes(value.toLowerCase())) ||
  //               (e?.barcode
  //                 ?.toString()
  //                 ?.toLowerCase()
  //                 ?.includes(value?.toString()?.toLowerCase()))) &&
  //             (e.status == "Restock" || e.status == "Out Of Stock") &&
  //             e.category == selectedCategory
  //           );
  //         })
  //     );
  //     return;
  //   }
  // };



  const handleSearchProducts2 =async (product) => {
// if (product?.target?.value.length > 3) {
  setSearchValueProduct2(product?.target?.value)
setSearchValueProduct("")
// }

    // console.log(product?.target?.value)
    // if (!product?.target?.value?.trim()) {
    //   setSearchCategory([]);
    //   fetchProducts(1,20)
    //   return;
    // }

    // try {
    //   const useExtendedSearch = product?.target?.value.length > 3; // Only use barcode/sku if length > 3
    //   // console.log(useExtendedSearch, "useExtendedSearch");
    //   if (!useExtendedSearch) return
    //   let dataToken = await sessionStorage.getItem("userData");
    //   dataToken = JSON.parse(dataToken);
    //   let token = dataToken;
    //   const response = await fetch(
    //     `${Base_Uri}getProducts?search=${encodeURIComponent(
    //       product?.target?.value
    //     )}&product=1&useExtendedSearch=${useExtendedSearch}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );
    //   const data = await response.json();

    //   if (data.status) {
    //     // setSearchCategory(data.data);
    //     setRows(data.data)
    //     setRowCount(data?.pagination?.totalDocs || 0);
    //   } else {
    //     setSearchCategory([]);
    //   }
    // } catch (error) {
    //   console.error("Error searching products:", error);
    // }
  };
  const handleSearchProducts = async (product) => {
    // setProductText(product);
    // if (product?.target?.value.length > 3) {
    setSearchValueProduct(product?.target?.value)
    setSearchValueProduct2("")
    // }
 // console.log(product?.target?.value)
    // if (!product?.target?.value?.trim()) {
    //   setSearchCategory([]);
    //   fetchProducts(1,20)
    //   return;
    // }

    // try {
    //   const useExtendedSearch = product?.target?.value.length > 3; // Only use barcode/sku if length > 3
    //   // console.log(useExtendedSearch, "useExtendedSearch");
    //   if (!useExtendedSearch) return
    //   let dataToken = await sessionStorage.getItem("userData");
    //   dataToken = JSON.parse(dataToken);
    //   let token = dataToken;
    //   const response = await fetch(
    //     `${Base_Uri}getProducts?search=${encodeURIComponent(
    //       product?.target?.value
    //     )}&useExtendedSearch=${useExtendedSearch}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );
    //   const data = await response.json();

    //   if (data.status) {
    //     // setSearchCategory(data.data);
    //     setRows(data.data)
    //     setRowCount(data?.pagination?.totalDocs || 0);
    //     console.log(data?.pagination?.totalDocs,"data.data.pagination?.totalDocs")
    //   } else {
    //     setSearchCategory([]);
    //   }
    // } catch (error) {
    //   console.error("Error searching products:", error);
    // }
  };

  const handleRestockProduct = () => {
    let restocKProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);

    if (restocKProduct.length > 0) {
      restocKProduct = restocKProduct[0];
    }

    setProductClicked(restocKProduct);
    setRestockModal(true);
  };

  const handleConfirmUpdate = () => {
    // getProducts();
    setSearchCategory([]);
    setRestockModal(false);
  };

  const handleOpenAddHistoryModal = () => {
    setLedgerLoading(true);

    let clickedProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);
    if (clickedProduct.length > 0) {
      clickedProduct = clickedProduct[0];
    }

    let barcode = clickedProduct?.barcode;

    axios
      .get(`${Base_Uri}getProductLedger/${barcode}`)
      .then((res) => {
        let data = res.data;

        if (!data.status) {
          message.info(data?.message);
          setLedgerLoading(false);
          return;
        }

        let ledgerData = data?.data;

        clickedProduct.productLedger = ledgerData;

        setProductClicked(clickedProduct);
        setLedgerLoading(false);
        setOpenAddProduct(true);
      })
      .catch((error) => {
        message.info(error?.message);
        setLedgerLoading(false);
        return;
      });
  };

  const handleOpenSaleHistoryModal = () => {
    setLedgerLoading(true);

    let clickedProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);
    if (clickedProduct.length > 0) {
      clickedProduct = clickedProduct[0];
    }

    let barcode = clickedProduct?.barcode;

    axios
      .get(`${Base_Uri}getProductLedger/${barcode}`)
      .then((res) => {
        let data = res.data;

        if (!data.status) {
          message.info(data?.message);
          setLedgerLoading(false);
          return;
        }

        let ledgerData = data?.data;

        clickedProduct.productLedger = ledgerData;

        setProductClicked(clickedProduct);
        setLedgerLoading(false);
        setOpenSaleHistoryModal(true);
      })
      .catch((error) => {
        message.info(error?.message);
        setLedgerLoading(false);
        return;
      });
  };

  const handleOpenSaleReturnHistoryModal = () => {
    setLedgerLoading(true);

    let clickedProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);
    if (clickedProduct.length > 0) {
      clickedProduct = clickedProduct[0];
    }

    let barcode = clickedProduct?.barcode;

    axios
      .get(`${Base_Uri}getProductLedger/${barcode}`)
      .then((res) => {
        let data = res.data;

        if (!data.status) {
          message.info(data?.message);
          setLedgerLoading(false);
          return;
        }

        let ledgerData = data?.data;
        clickedProduct.productLedger = ledgerData;

        setProductClicked(clickedProduct);
        setLedgerLoading(false);
        setOpenSaleReturnHistoryModal(true);
      })
      .catch((error) => {
        message.info(error?.message);
        setLedgerLoading(false);
        return;
      });
  };

  const handleOpenLedgerModal = () => {
    setLedgerLoading(true);

    let clickedProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);
    if (clickedProduct.length > 0) {
      clickedProduct = clickedProduct[0];
    }

    let barcode = clickedProduct?.barcode;

    axios
      .get(`${Base_Uri}getProductLedger/${barcode}`)
      .then((res) => {
        let data = res.data;

        if (!data.status) {
          setLedgerLoading(false);
          message.info(data?.message);
          return;
        }

        let ledgerData = data?.data;
        clickedProduct.productLedger = ledgerData;

        setProductClicked(clickedProduct);
        setLedgerLoading(false);
        setOpenLedgerModal(true);
      })
      .catch((error) => {
        message.info(error?.message);
        setLedgerLoading(false);
        return;
      });
  };

  const handleOpenBarcodeModal = (codeKey) => {
    let clickedProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);
    if (clickedProduct.length > 0) {
      clickedProduct = clickedProduct[0];
    }
    // console.log(clickedProduct, "clickedproduct");
    setProductClicked({ ...clickedProduct, codeKey });

    setOpenBarcodePrintModal(true);
  };

  const handleEditProduct = () => {
    let clickedProduct =
      product && product.length > 0 && product.filter((e, i) => e.selected);
    if (clickedProduct.length > 0) {
      clickedProduct = clickedProduct[0];
    }

    clickedProduct.edit = true;

    navigate("/Home", {
      state: clickedProduct,
    });
  };

  const inStockProductFilter = () => {
    if (!inStockFilter) {
      // let prodcccc =
      //   searchCategory && searchCategory.length != 0 ? searchCategory : product;
      // setSearchCategory(
      //   prodcccc &&
      //     prodcccc.length > 0 &&
      //     prodcccc.filter((e, i) => {
      //       return e.qty > 0;
      //     })
      // );
       setPaginationModel({ page: 0, pageSize: 20 })
      setInStockFilter(true);
    } else {
      setSearchCategory([]);
      setInStockFilter(false);
    }
  };
  const multipleSelectFilter = () => {
    setInMultipleSelectFilter(!inMultipleSelectFilter)
    setSelectedIds([])
    setRows((prev) =>
      prev.map((row) => ({
        ...row,
        selected: false,
      }))
    );

    // update products
    setProducts((prev) =>
      prev.map((p) => ({
        ...p,
        selected: false,
      }))
    );
  };

  useEffect(() => {
    const func = async()=>{
    if (barcodeData?.length > 0) {
      // console.log(barcodeData,"barcodeData")
      let product =
        products &&
        products?.length > 0 &&
        products?.find((e) => e?.barcode == barcodeData);
         let dataToken = await sessionStorage.getItem("userData");
                  dataToken = JSON.parse(dataToken);
                  let token = dataToken;
                  const response = await fetch(
                    `${Base_Uri}getProducts?search=${encodeURIComponent(
                      barcodeData
                    )}`,
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  const data = await response.json();
                  product = data?.data?.[0]

      if (product) {
        setSearchCategory([product]);
        setRows([product])
      }
      setBarcodeRead("");
    }
  }
  func()
  }, [barcodeData]);
  const fetchPaginatedDataWithQuery = async (
      url,
      token,
      queryParams = {},
      limit = 50,querys
    ) => {
      let page = 1;
      let allData = [];
      let hasMore = true;
  
      while (hasMore) {
        const query = new URLSearchParams({
          ...queryParams,
          pag: 1,
          page,
          limit,
        });
  
        try {
          const res = await axios.get(`${url}?${query.toString()}&query=${querys?JSON.stringify(querys):""}&search=${searchValueProduct||searchValueProduct2}&product=${searchValueProduct2?"1":""}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
  
          // if (currentData.length < limit) {
          //   hasMore = false;
          // } else {
          //   // console.log(allData,"/allData")
          //      let alld = allData.length!=0?[...allData.data]:[...allData]
          //   allData ={data:  [...alld, ...currentData],status:res?.data?.success}
  
          //   page++;
          // }
          if (res?.data?.status && Array.isArray(res.data.data)) {
            const currentData = res.data.data;
            // console.log(allData, "allData");
            // console.log(currentData, "currentData");
            let alld = allData.length != 0 ? [...allData.data] : [...allData];
            allData = {
              data: [...alld, ...currentData],
              status: res?.data?.status,
            };
            // console.log(res.data, "currentData/");
            if (currentData.length < limit) {
              hasMore = false;
            } else {
              page++;
            }
          } else {
            hasMore = false;
          }
        } catch (error) {
          console.error("Pagination error:", error);
          throw error;
        }
      }
      // console.log(allData, "allData");
      return allData;
    };

    const [exportReportLoading,setExportReportLoading] = useState(false)
    const formatForExcel = (e) => ({
  ProductName: e.product_name || e.productName || "",
  productDescription: e.product_description || "",
  colors: (e.product_color=="select"?"":e.product_color) || "",
  supplier_name: e.supplier_name || "",
  supplier_address: e.supplier_address || "",
  supplier_mobile_number: e.supplier_mobile_number || "",
  department: e.department || "",
  category: e.category || "",
  Sub_Category: e.sub_category || e.subcategory || "",
  make: e.make || "",
  model: e.model || "",
  qty: e.qty ?? "",
  remind: e.reminder_qty ?? "",
  cost_price: e.cost_price ?? "",
  diamond: e.diamond ?? "",
  platinum: e.trade_price ?? "",
  gold: e.warehouse_price ?? "",
  retail_price: e.retail_price ?? "",
  price_selected: e.price_selected || "",
  barCode: e.barcode || "",
  sku: e.sku || "",
  in_wordpress: e.in_wordpress ?? false,
  in_shopify: e.in_shopify ?? false,
  IMEI: e.IMEI || "",
  compatibility: e.compatibility || "",
  new_ledger: e.new_ledger ?? false,
  image1_url: e.image1_url || "",
  image2_url: e.image2_url || "",
  image3_url: e.image3_url || "",
});


  const exportToExcel = async() => {
    try {
      setExportReportLoading(true)
    let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;
    let productData = await fetchPaginatedDataWithQuery(`${Base_Uri}getProducts`,token,{},100)
    
const baseUrls = `${Image_Uri}products/`;

productData = productData?.data?.map(e => {
  const normalizeImage = (img) => {
    if (!img) return null;                 // param not exist
    if (img.startsWith("http")) return img; // already full URL
    return baseUrls + img;                  // local image
  };

  return {
    ...e,
    image1_url: normalizeImage(e?.image1_url),
    image2_url: normalizeImage(e?.image2_url),
    image3_url: normalizeImage(e?.image3_url),
  };
});  
 const excelData = (
  searchCategory.length > 0
        ? searchCategory
        : productData && productData?.length > 0
        ? productData
        : []
).map(formatForExcel);

const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, "data.xlsx");
    setExportReportLoading(false)
    } catch (error) {
      message.info("Product not successfully export")
      setExportReportLoading(false)
    }
  };
  const [pdfProductData,setPdfProductData] = useState([])
  const [isLoadProducts,setIsLoadProducts] = useState(false)
  const LoadProductsForPdf = async ()=>{
    setIsLoadProducts(true)
     let datas = await sessionStorage.getItem("userData");
        datas = JSON.parse(datas);
        let token = datas;
        let query = {
        isDep: selectedDepartment!="select"&&selectedDepartment!="All Departments"&&selectedDepartment,
        isCate:selectedCategory!="select"&&selectedCategory!="All Categories"&&selectedCategory,
        isActive:filter.active,
        isInActive:filter.inactive,
        // isRestock:filter.restock,
        inStock: inStockFilter,
       created_at:selectedDate?selectedDate:"",      
      }
    let productData = await fetchPaginatedDataWithQuery(`${Base_Uri}getProducts`,token,{},100,query)
    setPdfProductData(productData.data)
    setIsLoadProducts(false)
  }
  const [showCostPriceIsAccess, setShowCostPriceIsAccess] = useState(false);
  useEffect(() => {
    let roleAccess = userData?.role_access;
    let stockBooking =
      (roleAccess &&
        roleAccess?.length > 0 &&
        roleAccess?.find((e) => e.name == "ShowCostPrice")) ||
      userData.role == "admin";
    // console.log(stockBooking && stockBooking?.selected, "stockBooking");
    setShowCostPriceIsAccess(
      (stockBooking && stockBooking?.selected) || userData.role == "admin"
    );
  }, [userData]);
  const [rows, setRows] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 20 });
  const [rowCount, setRowCount] = useState(0);

   const priceKeyMap = {
  cost: "cost_price",
  diamond: "diamond",
  platinum: "trade_price",
  gold: "warehouse_price",
  retail: "retail_price",
};

const formatForExcel2 = (e) => {
  const row = {
    Barcode:e?.barcode,
    Sku:e?.sku,
    Imei:Array.isArray(e?.IMEI)?e?.IMEI?.join(","):e?.IMEI,
    Name: e?.product_name || e?.productName || "",
    Quantity: e?.qty ?? "",
  };

  AllPriceArrayToPrint.forEach((priceName) => {
    const key = priceKeyMap[priceName];
    if (key) {
      row[priceName] = e[key] ?? "";
    }
  });

  return row;
};


const exportToExcel2 = async() => {
    try {
   
 const excelData = (
  pdfProductData
).map(formatForExcel2);

const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, "data.xlsx");
    setExportReportLoading(false)
    } catch (error) {
      message.info("Product not successfully export")
      setExportReportLoading(false)
    }
  };
  const fetchProducts = async (page, limit) => {
    try {
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;
      let query = {
        isDep: selectedDepartment!="select"&&selectedDepartment!="All Departments"&&selectedDepartment,
        isCate:selectedCategory!="select"&&selectedCategory!="All Categories"&&selectedCategory,
        isActive:filter.active,
        isInActive:filter.inactive,
        // isRestock:filter.restock,
        inStock: inStockFilter,
       created_at:selectedDate?selectedDate:"",      
      }
      
      const response = await axios.get(`${Base_Uri}getProducts?page=${page + 1}&limit=${limit}&pag=1&query=${JSON.stringify(query)}&search=${searchValueProduct||searchValueProduct2}&product=${searchValueProduct2?"1":""}`,{headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", // Include other headers as needed
      },});
      setRows(response.data.data || []);
      // console.log(response.data.pagination?.totalDocs,"response.data.pagination?.totalDocs")
      setRowCount(response.data.pagination?.totalDocs || 0);
    } catch (err) {
      console.error("Failed to fetch products", err);
    }
  };
  useEffect(() => {
    if (!searchIsFilter) {
      fetchProducts(paginationModel.page, paginationModel.pageSize);
    }
  }, [paginationModel.page, paginationModel.pageSize, searchIsFilter,selectedDepartment,selectedCategory,filter,inStockFilter,selectedDate,searchValueProduct,searchValueProduct2]);

  const handlePaginationChange = (newModel) => {
    setPaginationModel(newModel);
    console.log(newModel)
  };

  
  return ledgerLoading ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
        width: "100%",
      }}
    >
      <RingLoader loading={ledgerLoading} size={100} color={Colors.black} />
    </Box>
  ) : loading ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
        width: "100%",
      }}
    >
      <RingLoader loading={loading} size={100} color={Colors.black} />
      <Typography
        style={{ fontSize: "24px", color: Colors.black, fontFamily: "Poppins" }}
      >
        Uploading Product...
      </Typography>
    </Box>
  ) : (
    <Box
      sx={{ padding: "20px", backgroundColor: Colors.white, marginTop: "20px" }}
    >
      {/* <Box sx={{ display: "flex" }}> */}
        <Row gutter={[5,5]}>
          <Col span={12}>
            <Row gutter={[5,5]}
              // sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
            >
              {/* <Grid item xs={1} sm={1} md={1}>
                <img
                  src={require("../../Images/filter.png")}
                  height={"15px"}
                  style={{ marginRight: "5px" }}
                />
              </Grid> */}
              <Col
                span={12}
              >
                <CustomButton
                  onClick={filterActiveProduct}
                  text="Active"
                  icon={
                    <img
                      src={require("../../Images/cross.png")}
                      height="15px"
                    />
                  }
                  style={{
                    width: "100%",
                    padding: "5px 5px 5px 5px",
                    fontSize: {
                      xl: "12px",
                      lg: "12px",
                      md: "10px",
                      sm: "10px",
                      xs: "8px",
                    },
                    display: "flex",
                    justifyContent: "space-around",
                    marginRight: "5px",
                    alignItems: "center",
                    backgroundColor: filter.active
                      ? Colors.button
                      : Colors.white,
                    color: filter.active ? Colors.white : Colors?.button,
                  }}
                />
              </Col>
              <Col
               span={12}
              >
                <CustomButton
                  onClick={filterRestockProduct}
                  text="Restock Product"
                  style={{
                    width: "100%",
                    padding: "5px 5px 5px 5px",
                    fontSize: {
                      xl: "12px",
                      lg: "12px",
                      md: "10px",
                      sm: "10px",
                      xs: "8px",
                    },
                    display: "flex",
                    justifyContent: "space-around",
                    marginRight: "5px",
                    alignItems: "center",
                    backgroundColor: filter.restock ? "#DC9E00" : Colors.white,
                    color: filter.restock ? Colors.white : "#DC9E00",
                    border: `1px solid #DC9E00`,
                  }}
                />
              </Col>
              <Col
                span={12}
              >
                <CustomButton
                  onClick={filterInactiveProduct}
                  text="Inactive Products"
                  style={{
                    width: "100%",
                    padding: "5px 5px 5px 5px",
                    fontSize: {
                      xl: "12px",
                      lg: "12px",
                      md: "10px",
                      sm: "10px",
                      xs: "8px",
                    },
                    display: "flex",
                    justifyContent: "space-around",
                    marginRight: "5px",
                    alignItems: "center",
                    backgroundColor: filter.inactive ? "#DC9E00" : Colors.white,
                    color: filter.inactive ? Colors.white : "#DC9E00",
                    border: `1px solid #DC9E00`,
                  }}
                />
              </Col>
              <Col
                span={12}
              >
                <BasicSelect
                  onChange={handleFilterCategory}
                  value={selectedCategory}
                  status="Category"
                  id={category}
                  innerStyle={{
                    fontSize: "12px",
                    border: `1px solid ${Colors.border}`,
                    borderRadius: 10,
                    fontWeight: "bold",
                    width:"100%",
                    // padding: "5px 5px 5px 5px",
                  }}
                  style={{ border: "0px" }}
                />
              </Col>
              <Col
                span={12}
              >
                <BasicSelect
                  onChange={handleFilterDepartment}
                  value={selectedDepartment}
                  status="Department"
                  id={department}
                  innerStyle={{
                    fontSize: "12px",
                    border: `1px solid ${Colors.border}`,
                    borderRadius: 10,
                    fontWeight: "bold",
                    width:"100%",
                    // padding: "5px 5px 5px 5px",
                  }}
                  style={{ border: "0px", }}
                />
              </Col>
              <Col
               span={12}
              >
                <CustomButton
                  onClick={() => inStockProductFilter()}
                  text="Instock Product"
                  style={{
                    width: "100%",
                    padding: "5px 5px 5px 5px",
                    fontSize: {
                      xl: "12px",
                      lg: "12px",
                      md: "10px",
                      sm: "10px",
                      xs: "8px",
                    },
                    display: "flex",
                    justifyContent: "space-around",
                    marginRight: "5px",
                    alignItems: "center",
                    backgroundColor: inStockFilter
                      ? "rgb(0, 183, 220)"
                      : Colors.white,
                    color: inStockFilter ? Colors.white : "rgb(0, 183, 220)",
                    border: `1px solid rgb(0, 183, 220)`,
                  }}
                />
              </Col>

              {/* {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "ExportProduct" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{ marginTop: 2 }}
                  text={exportReportLoading?"Downloading...":"Export Products"}
                  onClick={()=>exportReportLoading?()=>{}:exportToExcel()}
                />
              )}
              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "UploadProductOnWordPress" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{ marginTop: 2, marginLeft: 1 }}
                  text="Upload Products on Wordpress"
                  onClick={() => setIsWordpressUploadModal(true)}
                />
              )}

              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "DownloadProduct" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{
                    marginTop: 2,
                    marginLeft: 1,
                    width: 200,
                    marginBottom: 1,
                    marginRight: 10,
                  }}
                  text={"Download PDF"}
                  onClick={() => setIsOpenModalPriceSelect(true)}
                />
              )}
              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "syncquantities" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{
                    marginTop: 2,
                    marginLeft: 1,
                    width: 200,
                    marginBottom: 1,
                    marginRight: 10,
                  }}
                  text={"Sync Product from Wordpress"}
                  onClick={() => SyncProduct()}
                />
              )}
               {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "syncFromShopify" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{
                    marginTop: 2,
                    marginLeft: 1,
                    width: 200,
                    marginBottom: 1,
                    marginRight: 10,
                  }}
                  text={"Sync Product from Shopify"}
                  onClick={() => setIsModalOpen(true)}
                />
              )}
              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "CheckProductByDate" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{ marginTop: 2, marginLeft: 2 }}
                  text="Check Product By Date"
                  onClick={handleButtonClick}
                />
              )}
              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "UpdateProductwithCSV" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{ marginTop: 2, marginLeft: 2 }}
                  text="Update Product with CSV"
                  onClick={handleButtonClickFile}
                />
              )}

               {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "DeleteProductWithCsv" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
                <CustomButton
                  style={{ marginTop: 2, marginLeft: 2 }}
                  text="Delete Products with CSV"
                  onClick={()=>setIsModalOpen2(true)}
                />
              )}
              
                {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "MultipleSelect" && sub.selected
                    )
                )) ||
                userData.role == "admin") &&<CustomButton
                  onClick={() => multipleSelectFilter()}
                  text="Multiple Select"
                  style={{
                    // width: "100%",
                    padding: "5px 5px 5px 5px",
                    fontSize: {
                      xl: "12px",
                      lg: "12px",
                      md: "10px",
                      sm: "10px",
                      xs: "8px",
                    },
                    display: "flex",
                    justifyContent: "space-around",
                    marginLeft: "5px",
                    alignItems: "center",
                    width:150,
                    backgroundColor: inMultipleSelectFilter
                      ? "rgba(238, 53, 53, 1)"
                      : Colors.white,
                    color: inMultipleSelectFilter ? Colors.white : "rgba(254, 23, 23, 1)",
                    border: `1px solid rgba(254, 23, 23, 1)`,
                  }}
                />}
              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleExcelFileChange}
              /> */}
              {/* <DatePicker open={false} /> */}
            </Row>
            {/* {calendarVisible && (
              <Box>
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  inline
                  // clearButtonTitle="Show All Product"
                />
                <CustomButton
                  style={{ marginTop: 5, marginLeft: 1 }}
                  text="Clear Filter"
                  onClick={() => {
                    setSearchCategory([]);
                    setSearchIsFilter(false);
                    setCalendarVisible(false);
                    setSelectedDate(null)
                    // fetchProducts(paginationModel.page, paginationModel.pageSize)
                  }}
                />
              </Box>
            )} */}
          </Col>
          <Col span={12}>
            <Row
              gutter={[5,5]}
            >
              <Col span={23}>
                <Box
                  sx={{
                    width: "100%",
                    marginTop: { xs: "10px", sm: "10px", md: "0px" },
                    border: `1px solid ${Colors.button}`,
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "5px 10px 5px 10px",
                    margin: 0,
                  }}
                >
                  <TextField
                    variant="standard" // <== changed this
                    margin="normal"
                    required
                    fullWidth
                    value={searchValueProduct2}
                    InputProps={{
                      // startAdornment: <AccountCircle />, // <== adjusted this
                      disableUnderline: true,
                      fontSize: "12px",
                      // <== added this
                      // fontSize: "2px"
                    }}
                    onChange={handleSearchProducts2}
                    placeholder="Search By Product Name"
                    sx={{
                      width: "90%",
                      fontSize: "12px",
                      padding: 0,
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      margin: 0,
                    }}
                  />
                  <img
                    src={require("../../Images/clsoe.png")}
                    onClick={()=>setSearchValueProduct2("")}
                    style={{ height: "20px",cursor:"pointer" }}
                  />
                  <img
                    src={require("../../Images/search.png")}
                    style={{ height: "20px" }}
                  />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    marginTop: { xs: "10px", sm: "10px", md: "10px" },
                    border: `1px solid ${Colors.button}`,
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "5px 10px 5px 10px",
                    margin: 0,
                  }}
                >
                  <TextField
                    variant="standard" // <== changed this
                    margin="normal"
                    required
                    fullWidth
                    value={searchValueProduct}
                    InputProps={{
                      // startAdornment: <AccountCircle />, // <== adjusted this
                      disableUnderline: true,
                      fontSize: "12px",
                      // <== added this
                      // fontSize: "2px"
                    }}
                    onChange={(e)=>{
                      handleSearchProducts(e)

                    }}
                    placeholder="Search Name, Id, Phone, Sku, Imei, Category, SubCategory & Bar Code"
                    sx={{
                      width: "90%",
                      fontSize: "12px",
                      padding: 0,
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      margin: 0,
                    }}
                  />
                  <img
                    src={require("../../Images/clsoe.png")}
                    onClick={()=>setSearchValueProduct("")}
                    style={{ height: "20px",cursor:"pointer" }}
                  />
                  <img
                    src={require("../../Images/search.png")}
                    style={{ height: "20px" }}
                  />
                </Box>
              </Col>

              <Col span={1}>
              <Box
                sx={{
                  margin: 0,
                  height: "35px",
                  width: "35px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: Colors.button,
                }}
              >
                <img
                  src={require("../../Images/qrcode.png")}
                  style={{ height: "20px" }}
                />
              </Box></Col>
            </Row>
          </Col>
        </Row>
      {/* </Box> */}

      <Row gutter={[5,5]} style={{marginTop:10}}>
  {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "ExportProduct" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
<Col span={6}>
                <CustomButton
                  style={{width:"100%" }}
                  text={exportReportLoading?"Downloading...":"Export Products"}
                  onClick={()=>exportReportLoading?()=>{}:exportToExcel()}
                />
              </Col>
              )}

              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "UploadProductOnWordPress" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
             <Col span={6}>
                <CustomButton
                  style={{ width:"100%"}}
                  text="Upload Products on Wordpress"
                  onClick={() => setIsWordpressUploadModal(true)}
                />
              </Col>
              )}

              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "DownloadProduct" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
             <Col span={6}>
                <CustomButton
                  style={{
                   width:"100%"
                  }}
                  text={"Download PDF/EXCEL"}
                  onClick={() => setIsOpenModalPriceSelect(true)}
                />
              </Col>
              )}

              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "syncquantities" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
             <Col span={6}>
                <CustomButton
                  style={{
                    width:"100%"
                  }}
                  text={"Sync Product from Wordpress"}
                  onClick={() => SyncProduct()}
                />
              </Col>
              )}
               {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "syncFromShopify" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
               <Col span={6}>
                <CustomButton
                  style={{
                    width:"100%"
                  }}
                  text={"Sync Product from Shopify"}
                  onClick={() => setIsModalOpen(true)}
                />
              </Col>
              )}

              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "CheckProductByDate" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
              <Col span={6}>
                <CustomButton
                  style={{ width:"100%" }}
                  text="Check Product By Date"
                  onClick={handleButtonClick}
                />
              </Col>
              )}

              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "UpdateProductwithCSV" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
              <Col span={6}>
                <CustomButton
                  style={{ width:"100%" }}
                  text="Update Product with CSV"
                  onClick={handleButtonClickFile}
                />
              </Col>
              )}

               {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "DeleteProductWithCsv" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
              <Col span={6}>
                <CustomButton
                  style={{ width:"100%" }}
                  text="Delete Products with CSV"
                  onClick={()=>setIsModalOpen2(true)}
                />
              </Col>
              )}
              
                {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "MultipleSelect" && sub.selected
                    )
                )) ||
                userData.role == "admin") &&
                <Col span={6}>
                <CustomButton
                  onClick={() => multipleSelectFilter()}
                  text="Multiple Select"
                  style={{
                    // width: "100%",
                    // padding: "5px 5px 5px 5px",
                    fontSize: {
                      xl: "12px",
                      lg: "12px",
                      md: "10px",
                      sm: "10px",
                      xs: "8px",
                    },
                    display: "flex",
                    justifyContent: "space-around",
                    // marginLeft: "5px",
                    alignItems: "center",
                    width:"100%",
                    backgroundColor: inMultipleSelectFilter
                      ? "rgba(238, 53, 53, 1)"
                      : Colors.white,
                    color: inMultipleSelectFilter ? Colors.white : "rgba(254, 23, 23, 1)",
                    border: `1px solid rgba(254, 23, 23, 1)`,
                  }}
                />
                </Col>
                }

              <input
                type="file"
                id="fileInput"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleExcelFileChange}
              />
              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "UpdateBarcode" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
              <Col span={6}>
                <CustomButton
                  style={{ width:"100%" }}
                  text="Update Barcode"
                  onClick={()=>setIsModalBarcodeUpdate(true)}
                />
              </Col>
              )}
              {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) =>
                        sub.name === "UpdateSku" && sub.selected
                    )
                )) ||
                userData.role == "admin") && (
              <Col span={6}>
                <CustomButton
                  style={{ width:"100%" }}
                  text="Update SKU"
                  onClick={()=>setIsModalSkuUpdate(true)}
                />
              </Col>
              )}
              {calendarVisible && (
              <Box>
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  inline
                  // clearButtonTitle="Show All Product"
                />
                <CustomButton
                  style={{ marginTop: 5, marginLeft: 1 }}
                  text="Clear Filter"
                  onClick={() => {
                    setSearchCategory([]);
                    setSearchIsFilter(false);
                    setCalendarVisible(false);
                    setSelectedDate(null)
                    // fetchProducts(paginationModel.page, paginationModel.pageSize)
                  }}
                />
              </Box>
            )}
      </Row>

      {!inMultipleSelectFilter&&(product && product?.length > 0 && product.some((e, i) => e.selected) && (
        <Box sx={{ display: "flex", mt: 1, ml: 1 }}>
          <Grid container md={12} xs={12} sm={12}>
            <Grid item xs={12} sm={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Grid
                  item
                  xs={3}
                  sm={2}
                  md={3}
                  lg={3}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  <CustomButton
                    disabled={
                      checkAdminData.role == "admin"
                        ? false
                        : checkAdminData?.role_access
                            ?.filter((CA) => CA?.name == "StockBooking")[0]
                            ?.subcategory?.filter(
                              (Cc) => Cc?.name == "Delete Products"
                            )[0]?.selected
                        ? false
                        : true
                    }
                    onClick={() => !loader.delete && handleDeleteProducts()}
                    text={
                      loader.delete ? (
                        <RingLoader loading={loader.delete} size={30} />
                      ) : (
                        "Delete"
                      )
                    }
                    style={{
                      width: "100%",
                      padding: "5px 5px 5px 5px",
                      fontSize: {
                        xl: "12px",
                        lg: "12px",
                        md: "10px",
                        sm: "10px",
                        xs: "8px",
                      },
                      display: "flex",
                      justifyContent: "space-around",
                      marginRight: "5px",
                      alignItems: "center",
                      backgroundColor: Colors.red,
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={4}
                  lg={5}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  <CustomButton
                    onClick={() => !loader.active && handleActiveProducts()}
                    text={
                      loader.active ? (
                        <RingLoader size={30} loading={loader.active} />
                      ) : (
                        "Active"
                      )
                    }
                    style={{
                      width: "100%",
                      padding: "5px 5px 5px 5px",
                      fontSize: {
                        xl: "12px",
                        lg: "12px",
                        md: "10px",
                        sm: "10px",
                        xs: "8px",
                      },
                      display: "flex",
                      justifyContent: "space-around",
                      marginRight: "5px",
                      alignItems: "center",
                      backgroundColor: Colors.white,
                      color: "green",
                      border: `1px solid green`,
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={4}
                  lg={5}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  <CustomButton
                    onClick={handleInActiveProducts}
                    text="Inactive"
                    style={{
                      width: "100%",
                      padding: "5px 5px 5px 5px",
                      fontSize: {
                        xl: "12px",
                        lg: "12px",
                        md: "10px",
                        sm: "10px",
                        xs: "8px",
                      },
                      display: "flex",
                      justifyContent: "space-around",
                      marginRight: "5px",
                      alignItems: "center",
                      backgroundColor: Colors.white,
                      color: "purple",
                      border: `1px solid purple`,
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={4}
                  lg={5}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  {((userData?.role_access?.length != 0 &&
                userData.role_access?.some(
                  (role) =>
                    role?.subcategory &&
                    role?.subcategory?.some(
                      (sub) => sub.name === "RestockQuntity" && sub.selected
                    )
                )) ||
                userData.role == "admin")&&(product &&
                    product.length > 0 &&
                    product.filter((item) => item.selected).length == 1 && (
                      <CustomButton
                        onClick={() => handleRestockProduct()}
                        text="Restock"
                        style={{
                          width: "100%",
                          padding: "5px 5px 5px 5px",
                          fontSize: {
                            xl: "12px",
                            lg: "12px",
                            md: "10px",
                            sm: "10px",
                            xs: "8px",
                          },
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "5px",
                          alignItems: "center",
                          backgroundColor: Colors.white,
                          color: "purple",
                          border: `1px solid purple`,
                        }}
                      />
                    ))}
                </Grid>

                {/* {product && product.length > 0 && product.filter((item) => item.selected).length == 1 && <Grid item xs={4} sm={3} md={4} lg={5} xl={2.5} style={{ marginRight: "5px" }} >
                                <CustomButton onClick={() => navigate("/Home/ProductDetails")} text="View Detail" style={{ width: "100%", padding: "5px 5px 5px 5px", fontSize: { xl: "12px", lg: "12px", md: "10px", sm: "10px", xs: "8px" }, display: "flex", justifyContent: "space-around", marginRight: "5px", alignItems: "center", backgroundColor: Colors.button, color: "white", border: `1px solid purple` }} />
                            </Grid>} */}
              </Box>
            </Grid>
          </Grid>
        </Box>
      ))}

      {!inMultipleSelectFilter&&(product && product?.length > 0 && product.some((e, i) => e.selected) && (
        <Box sx={{ display: "flex", mt: 2, ml: 1 }}>
          <Grid container md={12} xs={12} sm={12}>
            <Grid item xs={12} sm={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Grid
                  item
                  xs={3}
                  sm={2}
                  md={3}
                  lg={3}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  {product &&
                    product.length > 0 &&
                    product.filter((item) => item.selected).length == 1 && (
                      <CustomButton
                        onClick={() => handleOpenAddHistoryModal()}
                        text={"Add History"}
                        style={{
                          width: "100%",
                          padding: "5px 5px 5px 5px",
                          fontSize: {
                            xl: "12px",
                            lg: "12px",
                            md: "10px",
                            sm: "10px",
                            xs: "8px",
                          },
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "5px",
                          alignItems: "center",
                          backgroundColor: Colors.green,
                        }}
                      />
                    )}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={4}
                  lg={5}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  {product &&
                    product.length > 0 &&
                    product.filter((item) => item.selected).length == 1 && (
                      <CustomButton
                        onClick={() => handleOpenSaleHistoryModal()}
                        text={"Sale History"}
                        style={{
                          width: "100%",
                          padding: "5px 5px 5px 5px",
                          fontSize: {
                            xl: "12px",
                            lg: "12px",
                            md: "10px",
                            sm: "10px",
                            xs: "8px",
                          },
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "5px",
                          alignItems: "center",
                          backgroundColor: Colors.white,
                          color: "green",
                          border: `1px solid green`,
                        }}
                      />
                    )}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={4}
                  lg={5}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  {product &&
                    product.length > 0 &&
                    product.filter((item) => item.selected).length == 1 && (
                      <CustomButton
                        onClick={() => handleOpenSaleReturnHistoryModal()}
                        text="Sale Return History"
                        style={{
                          width: "100%",
                          padding: "5px 5px 5px 5px",
                          fontSize: {
                            xl: "12px",
                            lg: "12px",
                            md: "10px",
                            sm: "10px",
                            xs: "8px",
                          },
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "5px",
                          alignItems: "center",
                          backgroundColor: Colors.white,
                          color: "purple",
                          border: `1px solid purple`,
                        }}
                      />
                    )}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={4}
                  lg={5}
                  xl={2.5}
                  style={{ marginRight: "5px" }}
                >
                  {(( checkAdminData.role == "admin"
                        ? true
                        : checkAdminData?.role_access
                            ?.filter((CA) => CA?.name == "StockBooking")[0]
                            ?.subcategory?.filter(
                              (Cc) => Cc?.name == "ProductLedger"
                            )[0]?.selected
                        ? true
                        : false)&&(product &&
                    product.length > 0 &&
                    product.filter((item) => item.selected).length == 1)) && (
                      <CustomButton
                        onClick={() => handleOpenLedgerModal()}
                        text="Ledger"
                        style={{
                          width: "100%",
                          padding: "5px 5px 5px 5px",
                          fontSize: {
                            xl: "12px",
                            lg: "12px",
                            md: "10px",
                            sm: "10px",
                            xs: "8px",
                          },
                          display: "flex",
                          justifyContent: "space-around",
                          marginRight: "5px",
                          alignItems: "center",
                          backgroundColor: Colors.white,
                          color: "purple",
                          border: `1px solid purple`,
                        }}
                      />
                    )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ))}

      {!inMultipleSelectFilter&&(<Grid container xs={12}>
        <Grid
          item
          xs={2}
          sm={3}
          md={2}
          lg={3}
          xl={2.5}
          style={{ marginRight: "10px", marginTop: 10 }}
        >
          {product &&
            product.length > 0 &&
            product.filter((item) => item.selected).length == 1 && (
              <CustomButton
                onClick={() => handleOpenBarcodeModal("bar")}
                text="Print Barcode"
                style={{
                  width: "200px",
                  padding: "5px 5px 5px 5px",
                  fontSize: {
                    xl: "12px",
                    lg: "12px",
                    md: "10px",
                    sm: "10px",
                    xs: "8px",
                  },
                  display: "flex",
                  justifyContent: "space-around",
                  marginRight: "5px",
                  alignItems: "center",
                  borderRadius: 1,
                  padding: 1,
                }}
              />
            )}
        </Grid>
        <Grid
          item
          xs={2}
          sm={3}
          md={2}
          lg={3}
          xl={2.5}
          style={{ marginRight: "10px", marginTop: 10 }}
        >
          {(product &&
            product.length > 0 &&
            product.filter((item) => item.selected).length == 1 && (
              <CustomButton
                onClick={() => handleOpenBarcodeModal("qr")}
                text="Print Qr Code"
                style={{
                  width: "200px",
                  padding: "5px 5px 5px 5px",
                  fontSize: {
                    xl: "12px",
                    lg: "12px",
                    md: "10px",
                    sm: "10px",
                    xs: "8px",
                  },
                  display: "flex",
                  justifyContent: "space-around",
                  marginRight: "5px",
                  alignItems: "center",
                  borderRadius: 1,
                  padding: 1,
                }}
              />
            ))}
        </Grid>

        <Grid
          item
          xs={2}
          sm={3}
          md={2}
          lg={3}
          xl={2.5}
          style={{ marginRight: "10px", marginTop: 10 }}
        >
          {product &&
            product.length > 0 &&
            product.filter((item) => item.selected).length == 1 && (
              <CustomButton
                onClick={() => handleEditProduct()}
                text="Edit Product"
                style={{
                  width: "200px",
                  padding: "5px 5px 5px 5px",
                  fontSize: {
                    xl: "12px",
                    lg: "12px",
                    md: "10px",
                    sm: "10px",
                    xs: "8px",
                  },
                  display: "flex",
                  justifyContent: "space-around",
                  marginRight: "5px",
                  alignItems: "center",
                  borderRadius: 1,
                  padding: 1,
                  backgroundColor: Colors.red,
                }}
              />
            )}
        </Grid>
      </Grid>)}

      {(selectedIds.length>0)&&(<Grid
          item
          xs={2}
          sm={3}
          md={2}
          lg={3}
          xl={2.5}
          style={{ marginRight: "10px", marginTop: 10 }}
        >
          {( (
              <Popconfirm onConfirm={()=>DeleteAllProducts()} title="Are You Sure?" description="Are you sure delete this products?">
                <CustomButton
                text="Delete All Products"
                style={{
                  width: "200px",
                  padding: "5px 5px 5px 5px",
                  fontSize: {
                    xl: "12px",
                    lg: "12px",
                    md: "10px",
                    sm: "10px",
                    xs: "8px",
                  },
                  display: "flex",
                  justifyContent: "space-around",
                  marginRight: "5px",
                  alignItems: "center",
                  borderRadius: 1,
                  padding: 1,
                }}
              />
              </Popconfirm>
            ))}
        </Grid>)}

      <Box
        sx={{
          height: "500px",
          backgroundColor: "white",
          marginTop: 5,
          minWidth: "100%",
        }}
      >
        <Paper>
        <div style={{height:600,overflow:"auto"}}>
          <DataGrid
      key={gridKey}
      paginationMode="server"
      rowCount={searchCategory.length > 0?searchCategory.length:rowCount}
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationChange}
      pageSizeOptions={[10, 20, 50, 100]}
      disableColumnFilter                              
      checkboxSelection={
        (userData?.role_access?.length > 0 &&
          userData.role_access?.some((role) =>
            role?.subcategory?.some(
              (sub) => sub.name === "ProductEditing" && sub.selected
            )
          )) || userData?.role === "admin"
      }
      disableRowSelectionOnClick
      onRowSelectionModelChange={(e)=>inMultipleSelectFilter?handleMultipleSelectionModelChange(e):handleSelectionModelChange(e)}
      rowSelectionModel={
        inMultipleSelectFilter?selectedIds:(rows?.length > 0
          ? rows.filter((e) => e?.selected)?.map((row) => row?.id)
          : [])
      }
      rows={
        searchIsFilter
          ? []
          : searchCategory.length > 0
          ? searchCategory
          : rows
      }
      columns={column}
      sx={{
        
        "& .MuiDataGrid-cell": {
          fontFamily: "Poppins",
          fontSize: "12px",
          fontWeight: "600",
          color: "#000",
        },
        "& .MuiDataGrid-colCell, & .MuiDataGrid-colCellTitle": {
          padding: "0px",
        },
        "& .MuiDataGrid-columnHeaderCheckbox": {
          backgroundColor: Colors.black,
          color: "white",
        },
        "& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root": {
          color: "gray",
        },
        "& .MuiDataGrid-columnHeader": {
          fontFamily: "Poppins",
          fontWeight: "bold",
           position: 'sticky',
      top: 0,
      zIndex: 10000,
        },
      }}
    />
        </div>
        </Paper>
        {restockModal && (
          <RestockModal
            data={productClicked}
            open={restockModal}
            confirm={() => handleConfirmUpdate()}
            closeModal={() => setRestockModal(false)}
          />
        )}

        {openAddProduct && (
          <AddProductModal
            data={productClicked}
            open={openAddProduct}
            closeModal={() => setOpenAddProduct(false)}
          />
        )}

        {openSaleHistoryModal && (
          <SaleHistoryModal
            data={productClicked}
            open={openSaleHistoryModal}
            closeModal={() => setOpenSaleHistoryModal(false)}
          />
        )}

        {openSaleReturnHistoryModal && (
          <SaleReturnHistoryModal
            data={productClicked}
            open={openSaleReturnHistoryModal}
            closeModal={() => setOpenSaleReturnHistoryModal(false)}
          />
        )}

        {openLedgerModal && (
          <LedgerModal
            data={productClicked}
            open={openLedgerModal}
            closeModal={() => setOpenLedgerModal(false)}
          />
        )}

        {openBarcodePrintModal && (
          <BarcodePrintModal
            heading={`Print ${productClicked?.codeKey=="qr"?"Qrcode":"Barcode"}`}
            loading={loading}
            reload={reloadPage}
            data={productClicked}
            setOpenBarcodePrintModal={setOpenBarcodePrintModal}
            open={openBarcodePrintModal}
            closeModal={() => setOpenBarcodePrintModal(false)}
            // confirm={}
          />
        )}

        <DescriptionModal
          open={openDescriptionModal}
          closeModal={() => setOpenDescriptionModal(false)}
          description={dataClicked?.product_description}
        />
      </Box>

      <Modal
        open={isWordpressUploadModal}
        onClose={() => setIsWordpressUploadModal(false)}
      >
        <Box sx={[style]}>
          <List
            sx={{
              width: "100%",
              overflow: "auto",
              maxHeight: 500,
            }}
          >
            {searchCategory.length == 0
              ? products?.map((value) => {
                  const labelId = `checkbox-list-label-${value._id}`;

                  return (
                    <ListItem key={value._id} disablePadding>
                      <ListItemButton
                        disabled={value?.in_wordpress}
                        role={undefined}
                        onClick={handleToggle(value._id)}
                        dense
                      >
                        <ListItemIcon>
                          <CHEckBox
                            edge="start"
                            checked={checked.includes(value._id)}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          id={labelId}
                          primary={`${value.product_name} - ${value.supplier_address} - ${value.sku}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })
              : searchCategory&&searchCategory?.map((value) => {
                  const labelId = `checkbox-list-label-${value._id}`;

                  return (
                    <ListItem key={value._id} disablePadding>
                      <ListItemButton
                        disabled={value?.in_wordpress}
                        role={undefined}
                        onClick={handleToggle(value._id)}
                        dense
                      >
                        <ListItemIcon>
                          <CHEckBox
                            edge="start"
                            checked={checked.includes(value._id)}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": labelId }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          id={labelId}
                          primary={`${value.product_name} - ${value.supplier_address} - ${value.sku}`}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
          </List>
          <CustomButton
            disabled={checked.length == 0}
            onClick={uploadBulkProductOnWordpress}
            style={{ marginTop: 2 }}
            text="Upload Products"
          />
        </Box>
      </Modal>
      <Modal
        open={isOpenModalPriceSelect}
        onClose={() => {
          setIsOpenModalPriceSelect(false)
          setPdfProductData([])
        }}
      >
        <Box sx={[style]}>
          <div style={{ fontSize: 16, color: "black", fontWeight: "600" }}>
            Select Price & Download Pdf/Excel
          </div>

          <CheckBoxGroup.Group
            value={AllPriceArrayToPrint}
            onChange={(e) => setAllPriceArrayToPrint(e)}
          >
            {showCostPriceIsAccess && (
              <CheckBoxGroup name="cost" value="cost">
                Cost
              </CheckBoxGroup>
            )}
            <CheckBoxGroup name="diamond" value="diamond">
              Diamond
            </CheckBoxGroup>
            <CheckBoxGroup name="platinum" value="platinum">
              Platinum
            </CheckBoxGroup>
            <CheckBoxGroup name="gold" value="gold">
              Gold
            </CheckBoxGroup>
            <CheckBoxGroup name="retail" value="retail">
              Retail
            </CheckBoxGroup>
          </CheckBoxGroup.Group>
          <CustomButton
                style={{
                  marginTop: 2,
                  marginLeft: 1,
                  width: "100%",
                  marginBottom: 1,
                  marginRight: 10,
                }}
                text={ isLoadProducts?"Loading Product...":pdfProductData?.length?"Products Loaded":"Load Products"}
                onClick={() =>pdfProductData?.length?()=>{}:LoadProductsForPdf() }
              />
          {(!isLoadProducts&&pdfProductData?.length)?<PDFDownloadLink
          
            document={
              <MyDocument
                data={
                pdfProductData
                }
                selectedDepartment={selectedDepartment}
                AllPriceArrayToPrint={AllPriceArrayToPrint}
              />
            }
            fileName="report.pdf"
            
          >
            {({ loading }) => (
              <CustomButton
              disabled={!isLoadProducts&&!pdfProductData?.length}
                style={{
                  marginTop: 2,
                  marginLeft: 1,
                  width: "100%",
                  marginBottom: 1,
                  marginRight: 10,
                }}
                text={loading ? "Loading document..." : "Download PDF"}
                // onClick={() => setIsWordpressUploadModal(true)}
              />
              // <Button variant="contained">
              //   {loading ? "Loading document..." : "Download PDF"}
              // </Button>
            )}
          </PDFDownloadLink>:<></>}

          {(!isLoadProducts&&pdfProductData?.length)?<CustomButton
              disabled={!isLoadProducts&&!pdfProductData?.length}
              onClick={exportToExcel2}
                style={{
                  marginTop: 2,
                  marginLeft: 1,
                  width: "100%",
                  marginBottom: 1,
                  marginRight: 10,
                }}
                text={loading ? "Loading document..." : "Download Excel"}
                // onClick={() => setIsWordpressUploadModal(true)}
              />:<></>}
          
        </Box>
      </Modal>

      <AntdModal title="Sync Progress"
        open={isModalOpen}
        onCancel={()=>setIsModalOpen(false)}
        // onClose={()=>setIsModalOpen(false)}
        footer={null}>
           <Upload beforeUpload={handleExcelUpload} showUploadList={false}>
        <AntdButton icon={<UploadOutlined />}>Upload Excel</AntdButton>
      </Upload>
{skuList.length>0&&(!jobId ? (
          <div style={{display:"flex",alignItems:"center",gap:10,marginTop:10}}>
            <div style={{ textAlign: "center" }}>
            <AntdButton type="primary" onClick={startSync}>
              Start Sync
            </AntdButton>
          </div>
          <Select
                style={{width:100}}
                  defaultValue="tp"
                  onChange={(e) => setSelectPriceStatusShopify(e)}
                   getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  options={[
                    { value: "cp", label: "Cost" },
                    { value: "di", label: "Diamond" },
                    { value: "tp", label: "Platinum" },
                    { value: "wp", label: "Gold" },
                    { value: "rp", label: "Retail" },
                  ]}
                />
          </div>
        ) : (
          <div>
            <h4>Status: {status}</h4>
            <Progress percent={progress} />
          </div>
        ))}

      </AntdModal>
      <AntdModal title="Delete Products"
        open={isModalOpen2}
        onCancel={()=>setIsModalOpen2(false)}
        // onClose={()=>setIsModalOpen(false)}
        footer={null}>
           <Upload beforeUpload={handleExcelUpload2} showUploadList={false}>
        <AntdButton icon={<UploadOutlined />}>Upload Excel</AntdButton>
      </Upload>
{barcodeBulkList.length>0&&( (
          <div style={{display:"flex",alignItems:"center",gap:10,marginTop:10}}>
            <div style={{ textAlign: "center" }}>
              <Popconfirm onConfirm={()=>DeleteAllProducts("barcode")} title="Are You Sure?" description="Are you sure delete this products?">

            <AntdButton type="primary">
              Start
            </AntdButton>
              </Popconfirm>
          </div>
          </div>
        ))}

      </AntdModal>

      <AntdModal title="Update Barcode"
        open={isModalBarcodeUpdate}
        onCancel={()=>setIsModalBarcodeUpdate(false)}
        // onClose={()=>setIsModalOpen(false)}
        footer={null}>
           <Typography
                        style={{
                          fontFamily: "Poppins",
                          fontSize: 18,
                          fontWeight: "600",
                          textAlign: "left",
                          marginTop:10
                        }}
                      >
                        Barcode (Dont inculde any Alphabate):
                      </Typography>
          
          <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "400px",
                      alignItems:"center"
                    }}
                  >
          
                  <Box style={{ marginTop: 10 }}>
                      
                      <input
                        value={addBarcode?.value}
                        onChange={(e) =>
                          setAddBarcode({
                            ...addBarcode,
                            value: e?.target?.value,
                          })
                        }
                        placeholder="Barcode"
                        style={{
                          width: "190px",
                          fontSize: "14px",
                          padding: 12,
                          borderRadius: 10,
                          border: "1px solid black",
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          margin: 0,
                        }}
                      />
                    </Box>
                    <CustomButton
                    onClick={updateBarcode}
                    text="Save Barcode"
                    style={{
                      width: "190px",
                      height:50,
                      borderRadius: 2,
                      fontSize: "14px",
                    }}
                  />
                  </Box>
        </AntdModal>

        <AntdModal title="Update Sku"
        open={isModalSkuUpdate}
        onCancel={()=>setIsModalSkuUpdate(false)}
        // onClose={()=>setIsModalOpen(false)}
        footer={null}>
           <Typography
                         style={{
                           fontFamily: "Poppins",
                           fontSize: 18,
                           fontWeight: "600",
                           textAlign: "left",
                           marginTop:5
                         }}
                       >
                         SKU (Dont inculde any Alphabate) :
                       </Typography>
           
           <Box
                     style={{
                       display: "flex",
                       justifyContent: "space-between",
                       width: "400px",
                       alignItems:"center"
                     }}
                   >
           
                   <Box style={{ marginTop: 10 }}>
                       
                       <input
                         value={addSku?.value}
                         onChange={(e) =>
                           setAddSku({
                             ...addSku,
                             value: e?.target?.value,
                           })
                         }
                         placeholder="SKU"
                         style={{
                           width: "190px",
                           fontSize: "14px",
                           padding: 12,
                           borderRadius: 10,
                           border: "1px solid black",
                           fontFamily: "Poppins",
                           fontWeight: "bold",
                           margin: 0,
                         }}
                       />
                     </Box>
                     <CustomButton
                     onClick={updateSku}
                     text="Save Sku"
                     style={{
                       width: "190px",
                       height:50,
                       borderRadius: 2,
                       fontSize: "14px",
                       
                     }}
                   />
                   </Box>
        </AntdModal>
    </Box>
  );
}

export default Products;
